(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["configurateur-pc"] && !Shopify.designMode) return;
  try {
    
 (() => {
  // Charge toutes les pages AVANT de construire les listes de compatibilité.
  // Les cartes restent rendues par Liquid : métachamps, variantes et prix conservés.
  async function loadCompleteCatalog(root, reportProgress) {
    const sectionId = root.dataset.pcSectionId;
    const lists = Array.from(root.querySelectorAll('[data-pc-product-page]'));
    const states = lists.map((list) => {
      const page = Number(list.dataset.pcPage);
      const reset = page !== 1 && list.dataset.pcLoadedFromStart !== 'true';
      if (page === 1) list.dataset.pcLoadedFromStart = 'true';
      const firstUrl = new URL(window.location.href);
      firstUrl.searchParams.delete('phcursor');
      firstUrl.searchParams.set(list.dataset.pcPageParam || 'page', '1');
      return {
        list,
        reset,
        expectedPage: reset ? 1 : page + 1,
        next: reset ? firstUrl.href : list.dataset.pcNextUrl,
        ids: new Set(Array.from(list.querySelectorAll('[data-pc-product]'),
          (button) => button.dataset.productId))
      };
    });

    function requestUrl(next) {
      const url = new URL(next, window.location.href);
      if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) {
        throw new Error('Lien de pagination inattendu. Rechargez la page.');
      }
      // Garder le contexte de prévisualisation du thème si Shopify omet ce paramètre.
      const current = new URL(window.location.href);
      for (const key of ['preview_theme_id', '_fd', 'pb']) {
        if (current.searchParams.has(key) && !url.searchParams.has(key)) {
          url.searchParams.set(key, current.searchParams.get(key));
        }
      }
      url.searchParams.delete('sections');
      url.searchParams.delete('sections[]');
      url.searchParams.set('section_id', sectionId);
      url.hash = '';
      url.searchParams.sort();
      return url.href;
    }

    for (const state of states) {
      if (Number(state.list.dataset.pcCatalogTotal) > 25000) {
        throw new Error('Cette collection dépasse 25 000 produits. Réduisez la collection utilisée dans le configurateur.');
      }
    }

    while (states.some((state) => state.next)) {
      if (!root.isConnected) return;
      const pending = states.filter((state) => state.next);
      const url = requestUrl(pending[0].next);
      // Une seule réponse peut fournir la page suivante de plusieurs catégories.
      const group = pending.filter((state) => requestUrl(state.next) === url);
      reportProgress('Chargement des composants… ' +
        states.reduce((count, state) => count + (state.reset ? 0 : state.ids.size), 0) +
        ' références récupérées.');
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 30000);
      let html;
      try {
        const response = await fetch(url, {
          credentials: 'same-origin',
          signal: controller.signal,
          headers: { Accept: 'text/html' }
        });
        if (!response.ok) throw new Error('Réponse Shopify ' + response.status);
        html = await response.text();
      } finally {
        window.clearTimeout(timeout);
      }
      if (!root.isConnected) return;
      const pageDocument = new DOMParser().parseFromString(html, 'text/html');
      const pageRoot = Array.from(pageDocument.querySelectorAll('[data-pc-configurator]'))
        .find((element) => element.dataset.pcSectionId === sectionId);
      if (!pageRoot) throw new Error('La section du configurateur n’a pas été renvoyée par Shopify.');

      for (const state of group) {
        const source = Array.from(pageRoot.querySelectorAll('[data-pc-product-page]'))
          .find((list) => list.dataset.pcBlockId === state.list.dataset.pcBlockId);
        if (!source || source.dataset.pcCollectionId !== state.list.dataset.pcCollectionId ||
            Number(source.dataset.pcPage) !== state.expectedPage) {
          throw new Error('Shopify n’a pas renvoyé la page de produits attendue.');
        }
        const cards = Array.from(source.querySelectorAll('.pc-configurator__product-card'));
        const ids = state.reset ? new Set() : new Set(state.ids);
        const fragment = document.createDocumentFragment();
        let added = 0;
        for (const card of cards) {
          const id = card.querySelector('[data-pc-product]')?.dataset.productId;
          if (!id) throw new Error('Une référence produit est manquante.');
          if (ids.has(id)) continue;
          ids.add(id);
          // Aucun script provenant du rendu distant n’est exécuté.
          card.querySelectorAll('script').forEach((script) => script.remove());
          fragment.appendChild(document.importNode(card, true));
          added++;
        }
        if (!added && (source.dataset.pcNextUrl || Number(source.dataset.pcCatalogTotal) > 0)) {
          throw new Error('La pagination n’avance plus. Rechargez la page.');
        }
        if (state.reset) state.list.replaceChildren();
        state.list.appendChild(fragment);
        state.ids = ids;
        state.reset = false;
        state.list.dataset.pcLoadedFromStart = 'true';
        state.list.dataset.pcPage = source.dataset.pcPage;
        state.list.dataset.pcCatalogTotal = source.dataset.pcCatalogTotal;
        state.list.dataset.pcNextUrl = source.dataset.pcNextUrl || '';
        state.next = state.list.dataset.pcNextUrl;
        state.expectedPage++;
      }
    }
    for (const state of states) {
      if (state.ids.size !== Number(state.list.dataset.pcCatalogTotal)) {
        throw new Error('Le catalogue a changé pendant le chargement. Rechargez la page pour récupérer toutes les références.');
      }
    }
  }

  async function prepareConfigurator(root) {
    if (!root || root.dataset.pcInitialised === 'true' || root.dataset.pcLoading === 'true') return;
    const lists = Array.from(root.querySelectorAll('[data-pc-product-page]'));
    const needsLoading = lists.some((list) =>
      list.dataset.pcNextUrl || Number(list.dataset.pcPage) !== 1 ||
      list.querySelectorAll('[data-pc-product]').length !== Number(list.dataset.pcCatalogTotal) ||
      Number(list.dataset.pcCatalogTotal) > 25000);
    if (!needsLoading) {
      initialiseConfigurator(root);
      return;
    }
    root.dataset.pcLoading = 'true';
    root.setAttribute('aria-busy', 'true');
    const previousDisplay = root.style.display;
    root.style.display = 'none';
    const notice = document.createElement('div');
    notice.className = 'pc-configurator__notice';
    notice.style.cssText = 'max-width:1200px;margin:24px auto;padding:24px;';
    const message = document.createElement('p');
    message.setAttribute('role', 'status');
    message.setAttribute('aria-live', 'polite');
    message.textContent = 'Chargement de toutes les références du configurateur…';
    const retry = document.createElement('button');
    retry.type = 'button';
    retry.className = 'pc-configurator__show-more';
    retry.textContent = 'Réessayer';
    retry.hidden = true;
    notice.append(message, retry);
    root.before(notice);

    async function attempt() {
      retry.hidden = true;
      message.textContent = 'Chargement de toutes les références du configurateur…';
      try {
        await loadCompleteCatalog(root, (text) => { message.textContent = text; });
      } catch (error) {
        if (!root.isConnected) { notice.remove(); return; }
        console.error('[Configurateur PC] Chargement du catalogue :', error);
        message.textContent = 'Impossible de charger tous les composants. ' +
          (error.name === 'AbortError' ? 'La connexion a pris trop de temps.' : error.message);
        retry.hidden = false;
        return;
      }
      if (!root.isConnected) { notice.remove(); return; }
      root.style.display = previousDisplay;
      root.removeAttribute('aria-busy');
      root.dataset.pcLoading = 'false';
      notice.remove();
      initialiseConfigurator(root);
      window.dispatchEvent(new Event('resize'));
    }
    retry.addEventListener('click', attempt);
    await attempt();
  }

  function initialiseConfigurator(root) {
    if (!root || root.dataset.pcInitialised === 'true') return;

    root.dataset.pcInitialised = 'true';

    const selections = new Map();
    
    const summary = root.querySelector('[data-pc-summary]');
    const totalElement = root.querySelector('[data-pc-total]');
    const addToCartButton = root.querySelector(
  '[data-pc-add-to-cart]'
);

const cartMessage = root.querySelector(
  '[data-pc-cart-message]'
);
const resetButton = root.querySelector(
  '[data-pc-reset]'
);
    const progressElement = root.querySelector('[data-pc-progress]');
    const productButtons = Array.from(
      root.querySelectorAll('[data-pc-product]')
    );

    const steps = Array.from(
      root.querySelectorAll('[data-pc-step]')
    );
    const navigationItems = Array.from(
      root.querySelectorAll('[data-pc-nav-item]')
    );
    const openStepButtons = Array.from(
      root.querySelectorAll('[data-pc-open-step]')
    );
    const closeCatalogButton = root.querySelector(
      '[data-pc-close-catalog]'
    );
    const activeLabelElement = root.querySelector(
      '[data-pc-active-label]'
    );
    const catalogStates = new Map();
    const productInformationCache = new Map();
    let activeCategory =
      steps.find((step) => step.classList.contains('is-active'))
        ?.dataset.category ||
      steps[0]?.dataset.category ||
      '';
    let lastInformationTrigger = null;
    let activeInformationUrl = '';
    let searchTimer = null;

    function normaliseSearchText(value) {
      return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
    }

    function getBatchSize() {
      return window.matchMedia('(max-width: 749px)').matches
        ? 10
        : 12;
    }

    function getCatalogState(category) {
      if (!catalogStates.has(category)) {
        catalogStates.set(category, {
          query: '',
          vendor: 'all',
          sort: 'price-asc',
          facets: {},
          limit: getBatchSize()
        });
      }

      return catalogStates.get(category);
    }

    function getStep(category) {
      return steps.find(
        (step) => step.dataset.category === category
      ) || null;
    }



    // Libellés des références du catalogue, sans modifier leurs handles.
    const metaobjectLabels = new Map();
    productButtons.forEach((product) => {
      try {
        const groups = JSON.parse(product.dataset.metaobjectLabels || '{}');
        Object.entries(groups).forEach(([kind, entries]) => {
          Object.entries(entries || {}).forEach(([handle, label]) => {
            if (handle && typeof label === 'string' && label.trim() && label !== handle) {
              metaobjectLabels.set(`${kind}:${handle}`, label.trim());
            }
          });
        });
      } catch (error) {
        // Un libellé absent n'empêche pas le filtrage par handle.
      }
    });

    const referenceLabels = {
      socket: { 'str5': 'sTR5', 'soc': 'SoC' },
      chipset: { 'soc': 'SoC (System on Chip)' },
      memoryType: {
        'ddr-4': 'DDR4', 'ddr-5': 'DDR5',
        'ddr-4-ou-ddr-5': 'DDR4 ou DDR5',
        'ddr-4-ecc-udimm': 'DDR4 ECC UDIMM',
        'ddr-4-ecc-rdimm-ou-lrdimm': 'DDR4 ECC RDIMM ou LRDIMM',
        'ddr-5-ecc-rdimm': 'DDR5 ECC RDIMM',
        'ddr-5-ecc-udimm': 'DDR5 ECC UDIMM',
        'ddr-5-udimm-ecc-ou-non-ecc': 'DDR5 UDIMM ECC ou non-ECC',
        'ddr-5-rdimm-ou-mrdimm': 'DDR5 RDIMM ou MRDIMM',
        'ddr-5-so-dimm': 'DDR5 SO-DIMM'
      },
      motherboardFormat: {
        'atx': 'ATX', 'e-atx': 'E-ATX', 'micro-atx': 'Micro-ATX',
        'mini-itx': 'Mini-ITX', 'thin-mini-itx': 'Thin Mini-ITX',
        'deep-mini-itx': 'Deep Mini-ITX', 'deep-micro-atx': 'Deep Micro-ATX',
        'eeb': 'EEB', 'ceb': 'CEB', 'ssi-eeb': 'SSI-EEB', 'ssi-ceb': 'SSI-CEB',
        'proprietary': 'Propriétaire'
      },
      psuFormat: { 'atx': 'ATX', 'sfx': 'SFX', 'sfx-l': 'SFX-L',
        'tfx': 'TFX', 'flex-atx': 'Flex-ATX' },
      caseSize: { 'mini-tour': 'Mini-Tour', 'moyen-tour': 'Moyen-Tour',
        'grand-tour': 'Grand-Tour' }
    };

    function referenceLabel(kind, handle) {
      const saved = metaobjectLabels.get(`${kind}:${handle}`);
      if (saved) return saved;
      const labelKind = kind === 'compatibleChipset' ? 'chipset' : kind;
      const known = referenceLabels[labelKind]?.[handle];
      if (known) return known;
      if (kind === 'socket') {
        if (/^lga-/.test(handle)) return handle.replace(/^lga-/, 'LGA ');
        if (/^(am|sp)-?\d+$/i.test(handle)) return handle.replace(/-/g, '').toUpperCase();
      }
      if (labelKind === 'chipset') return handle.replace(/-/g, '').toUpperCase();
      if (kind === 'radiatorSize' && /^\d+(?:-mm)?$/.test(handle)) {
        return `${handle.replace(/-mm$/, '')} mm`;
      }
      const readable = handle.replace(/-/g, ' ');
      return readable.charAt(0).toUpperCase() + readable.slice(1);
    }

    function buildReferenceFilter(step, selector, dataKey, kind, products, sourceKey, decorate) {
      const container = step.querySelector(selector)?.querySelector('.pc-configurator__filter-buttons');
      if (!container) return;
      const values = Array.from(new Set(products.map((product) =>
        product.dataset[sourceKey] || '').filter(Boolean))).sort((a, b) =>
          referenceLabel(kind, a).localeCompare(referenceLabel(kind, b), 'fr', {
            numeric: true, sensitivity: 'base'
          })
        );
      const buttons = [['all', 'Tous'], ...values.map((value) =>
        [value, referenceLabel(kind, value)])].map(([value, label]) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'pc-configurator__filter-button' +
            (value === 'all' ? ' is-active' : '');
          button.dataset[dataKey] = value;
          button.setAttribute('aria-pressed', String(value === 'all'));
          button.textContent = label;
          if (value !== 'all' && decorate) decorate(button, value);
          return button;
        });
      container.replaceChildren(...buttons);
    }

    function buildMetaobjectFilters() {
      steps.forEach((step) => {
        const products = Array.from(step.querySelectorAll('[data-pc-product]'));
        if (step.dataset.category === 'cpu') {
          buildReferenceFilter(step, '[data-pc-cpu-socket-filters]',
            'pcCpuSocketFilter', 'socket', products, 'socket', (button, socket) => {
              const brands = new Set(products.filter((product) =>
                product.dataset.socket === socket).map((product) => product.dataset.cpuBrand).filter(Boolean));
              button.dataset.pcSocketBrand = brands.size === 1 ? Array.from(brands)[0] : '';
            });
        }
        if (step.dataset.category === 'motherboard') {
          buildReferenceFilter(step, '[data-pc-motherboard-filters]',
            'pcMotherboardSocketFilter', 'socket', products, 'socket');
          buildReferenceFilter(step, '[data-pc-motherboard-chipset-filters]',
            'pcMotherboardChipsetFilter', 'chipset', products, 'chipset', (button, chipset) => {
              // Un même chipset, notamment SoC, peut être présent sur plusieurs sockets.
              button.dataset.pcChipsetSockets = Array.from(new Set(products.filter((product) =>
                product.dataset.chipset === chipset).map((product) => product.dataset.socket)
                .filter(Boolean))).join('|');
            });
        }
      });
    }

    // Une option par valeur réellement présente dans le catalogue chargé.
    const facetDefinitions = {
      cpu: [
        { key: 'compatibleChipsets', label: 'Chipsets compatibles', reference: 'compatibleChipset' },
        { key: 'memoryType', label: 'Type de mémoire', reference: 'memoryType' }
      ],
      storage: [{ key: 'capacity', label: 'Capacité',
        fixed: [
          ['up-to-256', 'Jusqu’à 256 Go'],
          ['480-512', '480 à 512 Go'], ['1tb', '1 To'],
          ['2tb', '2 To'], ['4tb', '4 To'], ['8tb', '8 To']
        ] }],
      ram: [
        { key: 'modules', label: 'Nombre de barrettes', unit: '' },
        { key: 'capacity', label: 'Capacité en Go', unit: ' Go' },
        { key: 'frequency', label: 'Fréquence mémoire', unit: ' MHz' }
      ],
      psu: [
        { key: 'power', label: 'Puissance', unit: ' W' },
        { key: 'certification', label: 'Certification' }
      ],
      motherboard: [
        { key: 'format', label: 'Format de carte mère', reference: 'motherboardFormat' },
        { key: 'memoryType', label: 'Type de mémoire', reference: 'memoryType' }
      ],
      case: [
        { key: 'format', label: 'Format du boîtier', reference: 'caseSize' },
        { key: 'motherboardFormats', label: 'Cartes mères compatibles', reference: 'motherboardFormat' },
        { key: 'psuFormats', label: 'Formats d’alimentation', reference: 'psuFormat' },
        { key: 'radiatorSizes', label: 'Radiateurs compatibles', reference: 'radiatorSize' }
      ],
      gpu: [{ key: 'chipset', label: 'Chipset' }]
    };

    function capacityInGb(value) {
      const match = String(value || '').match(
        /(?:^|[^a-z0-9])([0-9]+(?:[.,][0-9]+)?)\s*(to|tb|go|gb)(?=$|[^a-z])/i
      );
      if (!match) return 0;
      const amount = Number(match[1].replace(',', '.'));
      return amount * (/^(to|tb)$/i.test(match[2]) ? 1000 : 1);
    }

    function storageVariantCapacity(variant, product) {
      return capacityInGb(variant?.dataset.storageCapacity) ||
        capacityInGb(variant?.dataset.variantTitle) ||
        capacityInGb(product.dataset.storageCapacity) ||
        capacityInGb(product.dataset.productTitle);
    }

    function capacityBucket(capacity) {
      if (capacity > 0 && capacity <= 256) return 'up-to-256';
      if (capacity >= 480 && capacity <= 512) return '480-512';
      for (const [size, label] of [
        [1000, '1tb'], [2000, '2tb'],
        [4000, '4tb'], [8000, '8tb']
      ]) {
        if (Math.abs(capacity - size) <= size * 0.05) return label;
      }
      return '';
    }

    function numericFacet(raw, fallback) {
      const numberText = String(raw ?? '').trim()
        .replace(/^'+/, '')
        .replace(/[ \u00a0\u202f](?=\d{3}(?:\D|$))/g, '')
        .replace(',', '.');
      const value = Number.parseFloat(numberText);
      return Number.isFinite(value) && value > 0
        ? String(value) : (fallback || '');
    }

    function gpuChipset(product) {
      const source = `${product.dataset.gpuChipset || ''} ` +
        `${product.dataset.productTitle || ''}`;
      const match = source.match(
        /\b(RTX|RX)[\s-]*([0-9]{4,5})(?:[\s-]*(Ti|SUPER|XT|XTX|GRE))?(?:[\s-]*(SUPER))?\b/i
      );
      return match ? [match[1].toUpperCase(), match[2],
        match[3]?.toUpperCase(), match[4]?.toUpperCase()]
        .filter(Boolean).join(' ') : '';
    }

    function psuCertification(product) {
      // Utiliser la certification enregistrée dans le métachamp du produit.
      const source = String(product.dataset.psuCertification || '').trim();
      // Cybenetics possède ses propres niveaux, distincts de 80 PLUS.
      if (/\bcybenetics\b/i.test(source)) {
        const cybeneticsLevel = source.match(
          /\b(Bronze|Silver|Gold|Platinum|Titanium|Diamond)\b/i
        );
        if (!cybeneticsLevel) return 'Cybenetics';
        const level = cybeneticsLevel[1];
        return `Cybenetics ${level[0].toUpperCase()}${level.slice(1).toLowerCase()}`;
      }
      const match = source.match(
        /(?:80[\s+-]*(?:plus)?[\s-]*)?(Titanium|Platinum|Gold|Silver|Bronze|White)\b/i
      );
      if (match) {
        const level = match[1][0].toUpperCase() + match[1].slice(1).toLowerCase();
        return level === 'White' ? '80 PLUS' : `80 PLUS ${level}`;
      }
      return /\b80(?:[\s-]*plus\b|\s*\+)/i.test(source) ? '80 PLUS' : '';
    }

    function caseFormat(product) {
      const explicit = (product.dataset.caseSize || '').trim();
      const source = normaliseSearchText(explicit || product.dataset.productTitle);
      if (/\bmini (tour|tower)\b/.test(source)) return 'mini-tour';
      if (/\b(moyen tour|moyenne tour|mid tower|midi tower)\b/.test(source)) return 'moyen-tour';
      if (/\b(grand tour|grande tour|full tower)\b/.test(source)) return 'grand-tour';
      return explicit;
    }

    function getFacetValue(category, key, product) {
      const title = product.dataset.productTitle || '';
      if (category === 'cpu') {
        if (key === 'compatibleChipsets') return parseList(product.dataset.compatibleChipsets);
        if (key === 'memoryType') return product.dataset.memoryType || '';
      }
      if (category === 'ram') {
        if (key === 'modules') return numericFacet(product.dataset.ramModules,
          (title.match(/\b([1248])\s*[x×]\s*\d+\s*Go\b/i) || [])[1]);
        if (key === 'capacity') {
          const kit = title.match(/\b([1248])\s*[x×]\s*(\d+)\s*Go\b/i);
          const total = kit ? String(Number(kit[1]) * Number(kit[2])) : '';
          return numericFacet(product.dataset.ramCapacity, total ||
            (title.match(/\b(8|16|24|32|48|64|96|128|256)\s*Go\b/i) || [])[1]);
        }
        if (key === 'frequency') return numericFacet(product.dataset.ramFrequency,
          (title.match(/\b(2[14-9]33|[345678][0-9]{3})\s*(?:MHz|MT\/s)\b/i) || [])[1]);
      }
      if (category === 'psu') {
        if (key === 'power') return numericFacet(product.dataset.psuPower,
          (title.match(/\b(\d{3,4})\s*W\b/i) || [])[1]);
        if (key === 'certification') return psuCertification(product);
      }
      if (category === 'motherboard') {
        if (key === 'format') return product.dataset.motherboardFormat || '';
        if (key === 'memoryType') return product.dataset.memoryType || '';
      }
      if (category === 'case') {
        if (key === 'format') return caseFormat(product);
        if (key === 'motherboardFormats') return parseList(product.dataset.supportedMotherboardFormats);
        if (key === 'psuFormats') return parseList(product.dataset.supportedPsuFormats);
        if (key === 'radiatorSizes') return parseList(product.dataset.supportedRadiatorSizes);
      }
      if (category === 'gpu' && key === 'chipset') return gpuChipset(product);
      return '';
    }

    function storageMatchingVariants(card, bucket) {
      const product = card.querySelector('[data-pc-product]');
      if (!product) return [];
      const variants = Array.from(card.querySelectorAll('[data-pc-variant]'));
      if (!variants.length) {
        return capacityBucket(storageVariantCapacity(null, product)) === bucket
          && product.dataset.selectedVariantAvailable !== 'false' ? [null] : [];
      }
      return variants.filter((variant) =>
        variant.dataset.variantAvailable === 'true' &&
        capacityBucket(storageVariantCapacity(variant, product)) === bucket
      );
    }

    function selectStorageVariant(card, variant) {
      const product = card.querySelector('[data-pc-product]');
      if (!product || !variant ||
          product.getAttribute('aria-pressed') === 'true' ||
          variant.getAttribute('aria-pressed') === 'true') return;
      card.querySelectorAll('[data-pc-variant]').forEach((candidate) =>
        candidate.setAttribute('aria-pressed', String(candidate === variant))
      );
      product.dataset.variantId = variant.dataset.variantId || '';
      product.dataset.price = variant.dataset.variantPrice || '0';
      product.dataset.sortPrice = product.dataset.price;
      product.dataset.selectedVariantAvailable = 'true';
      const reason = getCompatibilityReason(product);
      product.disabled = product.dataset.productAvailable !== 'true' || Boolean(reason);
      product.classList.toggle('is-incompatible', Boolean(reason));
      product.classList.remove('is-variant-unavailable');
      const message = product.querySelector('[data-pc-compatibility-message]');
      if (message) {
        message.textContent = reason || '';
        message.hidden = !reason;
      }
      const price = product.querySelector('[data-pc-product-price]');
      if (price) price.textContent = formatMoney(parseNumber(product.dataset.price));
      const image = product.querySelector('[data-pc-product-image]');
      if (image && variant.dataset.variantImageSrc) {
        image.src = variant.dataset.variantImageSrc;
        image.alt = variant.dataset.variantImageAlt || product.dataset.productTitle || '';
      }
    }

    function matchesFacets(category, card, selected) {
      const product = card.querySelector('[data-pc-product]');
      if (!product) return false;
      for (const [key, value] of Object.entries(selected)) {
        if (!value || value === 'all') continue;
        if (category === 'storage' && key === 'capacity') {
          const matching = storageMatchingVariants(card, value);
          if (!matching.length) return false;
          if (product.getAttribute('aria-pressed') === 'true' &&
              matching.filter(Boolean).length &&
              !matching.some((variant) =>
                variant?.getAttribute('aria-pressed') === 'true'
              )) return false;
          // Le prix et la photo suivent la variante affichée dans les résultats.
          const cheapest = matching.filter(Boolean).sort((a, b) =>
            parseNumber(a.dataset.variantPrice) - parseNumber(b.dataset.variantPrice)
          )[0];
          selectStorageVariant(card, cheapest);
        } else {
          const actual = getFacetValue(category, key, product);
          if (Array.isArray(actual) ? !actual.includes(value) : actual !== value) return false;
        }
      }
      return true;
    }

    function buildFacetFilters() {
      steps.forEach((step) => {
        const definitions = facetDefinitions[step.dataset.category] || [];
        const container = step.querySelector('[data-pc-facets]');
        if (!container) return;
        const products = Array.from(step.querySelectorAll('[data-pc-product]'));
        for (const definition of definitions) {
          const present = new Set();
          products.forEach((product) => {
            if (step.dataset.category === 'storage') {
              const card = product.closest('.pc-configurator__product-card');
              definition.fixed.forEach(([bucket]) => {
                if (storageMatchingVariants(card, bucket).length) present.add(bucket);
              });
            } else {
              const value = getFacetValue(step.dataset.category,
                definition.key, product);
              (Array.isArray(value) ? value : [value]).filter(Boolean)
                .forEach((item) => present.add(item));
            }
          });
          const entries = definition.fixed
            ? definition.fixed.filter(([value]) => present.has(value))
            : Array.from(present).sort((a, b) => {
                if (/^\d+$/.test(a) && /^\d+$/.test(b)) return Number(a) - Number(b);
                return a.localeCompare(b, 'fr', { numeric: true });
              }).map((value) => [value, definition.reference
                ? referenceLabel(definition.reference, value)
                : value + (definition.unit || '')]);
          if (definition.reference) {
            entries.sort((a, b) => a[1].localeCompare(b[1], 'fr', {
              numeric: true, sensitivity: 'base'
            }));
          }
          if (!entries.length) continue;
          const group = document.createElement('div');
          group.className = 'pc-configurator__facet';
          group.dataset.pcFacetGroup = definition.key;
          const label = document.createElement('span');
          label.className = 'pc-configurator__filter-label';
          label.textContent = definition.label;
          const buttons = document.createElement('div');
          buttons.className = 'pc-configurator__filter-buttons';
          buttons.setAttribute('role', 'group');
          buttons.setAttribute('aria-label', `Filtrer par ${definition.label.toLowerCase()}`);
          [['all', 'Tous'], ...entries].forEach(([value, text]) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'pc-configurator__filter-button' +
              (value === 'all' ? ' is-active' : '');
            button.dataset.pcFacetValue = value;
            button.setAttribute('aria-pressed', String(value === 'all'));
            button.textContent = text;
            buttons.appendChild(button);
          });
          group.append(label, buttons);
          container.appendChild(group);
        }
      });
    }

    function buildVendorFilters() {
      steps.forEach((step) => {
        const container = step.querySelector(
          '[data-pc-vendor-filters]'
        );

        if (!container) return;

        /* Le processeur possède déjà ses boutons AMD / Intel. */
        if (step.dataset.category === 'cpu') {
          container.hidden = true;
          return;
        }

        const vendors = new Map();

        step
          .querySelectorAll('[data-pc-product]')
          .forEach((button) => {
            const label = String(
              button.dataset.productVendor || ''
            ).trim();
            const key = normaliseSearchText(label);

            if (label && key && !vendors.has(key)) {
              vendors.set(key, label);
            }
          });

        if (vendors.size < 2) {
          container.hidden = true;
          return;
        }

        const label = document.createElement('span');
        label.className = 'pc-configurator__filter-label';
        label.textContent = 'Marque';

        const buttons = document.createElement('div');
        buttons.className = 'pc-configurator__filter-buttons';
        buttons.setAttribute('role', 'group');
        buttons.setAttribute(
          'aria-label',
          `Filtrer ${step.dataset.label || 'les produits'} par marque`
        );

        const allButton = document.createElement('button');
        allButton.type = 'button';
        allButton.className =
          'pc-configurator__filter-button is-active';
        allButton.dataset.pcVendorFilter = 'all';
        allButton.setAttribute('aria-pressed', 'true');
        allButton.textContent = 'Toutes';
        buttons.appendChild(allButton);

        Array.from(vendors.entries())
          .sort((a, b) =>
            a[1].localeCompare(b[1], 'fr', {
              sensitivity: 'base'
            })
          )
          .forEach(([key, vendorLabel]) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className =
              'pc-configurator__filter-button';
            button.dataset.pcVendorFilter = key;
            button.setAttribute('aria-pressed', 'false');
            button.textContent = vendorLabel;
            buttons.appendChild(button);
          });

        container.replaceChildren(label, buttons);
      });

      steps.forEach((step) => {
        const panel = step.querySelector(
          '[data-pc-filters-panel]'
        );
        const toggle = step.querySelector(
          '[data-pc-toggle-filters]'
        );
        const hasFilter = Boolean(
          panel?.querySelector(
            '[data-pc-vendor-filter], ' +
              '[data-pc-cpu-brand-filter], ' +
              '[data-pc-cpu-socket-filter], ' +
              '[data-pc-motherboard-socket-filter], ' +
              '[data-pc-motherboard-chipset-filter], ' +
              '[data-pc-cooling-type-filter], ' +
              '[data-pc-radiator-size-filter], ' +
              '[data-pc-facet-value]'
          )
        );

        if (panel) panel.hidden = !hasFilter;
        if (toggle) toggle.hidden = !hasFilter;
      });
    }

    function refreshCatalog(category, options = {}) {
      const step = getStep(category);
      if (!step) return;

      const state = getCatalogState(category);

      if (options.resetLimit) {
        state.limit = getBatchSize();
      }

      const productsContainer = step.querySelector(
        '.pc-configurator__products'
      );
      const cards = productsContainer
        ? Array.from(
            productsContainer.querySelectorAll(
              '.pc-configurator__product-card'
            )
          )
        : [];

      const queryTokens = normaliseSearchText(state.query)
        .split(' ')
        .filter(Boolean);

      cards.forEach((card, index) => {
        if (!card.dataset.originalIndex) {
          card.dataset.originalIndex = String(index);
        }

        const button = card.querySelector('[data-pc-product]');
        if (!button) return;
        if (!button.dataset.sortPrice) {
  button.dataset.sortPrice = button.dataset.price || '0';
}

        const searchableText = normaliseSearchText(
          button.dataset.searchText ||
            `${button.dataset.productVendor || ''} ${
              button.dataset.productTitle || ''
            }`
        );
        const compactSearchableText = searchableText.replace(
          /\s+/g,
          ''
        );
        const vendor = normaliseSearchText(
          button.dataset.productVendor
        );
        const matchesSearch = queryTokens.every((token) =>
          searchableText.includes(token) ||
          compactSearchableText.includes(token.replace(/\s+/g, ''))
        );
        const matchesVendor =
          state.vendor === 'all' || vendor === state.vendor;
        const isCompatible =
          !button.classList.contains('is-incompatible');
        const matchesFacet = matchesFacets(category, card, state.facets);

        card.classList.toggle(
          'is-search-filtered-out',
          !matchesSearch
        );
        card.classList.toggle(
          'is-vendor-filtered-out',
          !matchesVendor
        );
        card.classList.toggle('is-facet-filtered-out', !matchesFacet);
        card.classList.toggle(
          'is-compatibility-filtered-out',
          !isCompatible
        );
        card.classList.remove('is-limit-hidden');
      });

      const sortedCards = [...cards].sort((cardA, cardB) => {
        const buttonA = cardA.querySelector('[data-pc-product]');
        const buttonB = cardB.querySelector('[data-pc-product]');
        const priceA = parseNumber(
  buttonA?.dataset.sortPrice || buttonA?.dataset.price
);

const priceB = parseNumber(
  buttonB?.dataset.sortPrice || buttonB?.dataset.price
);
        const nameA = buttonA?.dataset.productTitle || '';
        const nameB = buttonB?.dataset.productTitle || '';

        if (state.sort === 'price-desc') {
          return priceB - priceA;
        }

        if (state.sort === 'name-asc') {
          return nameA.localeCompare(nameB, 'fr', {
            sensitivity: 'base',
            numeric: true
          });
        }

        return priceA - priceB;
      });

      const orderChanged = sortedCards.some(
  (card, index) => cards[index] !== card
);

if (orderChanged && productsContainer) {
  const fragment = document.createDocumentFragment();

  sortedCards.forEach((card) => {
    fragment.appendChild(card);
  });

  productsContainer.appendChild(fragment);
}

      const eligibleCards = sortedCards.filter(
        (card) =>
          !card.classList.contains('is-brand-filtered-out') &&
          !card.classList.contains('is-search-filtered-out') &&
          !card.classList.contains('is-vendor-filtered-out') &&
          !card.classList.contains('is-facet-filtered-out') &&
          !card.classList.contains(
            'is-compatibility-filtered-out'
          )
      );

      eligibleCards.forEach((card, index) => {
        card.classList.toggle(
          'is-limit-hidden',
          index >= state.limit
        );
      });

      const resultCount = step.querySelector(
        '[data-pc-results-count]'
      );
      const shownCount = Math.min(
        state.limit,
        eligibleCards.length
      );

      if (resultCount) {
        if (eligibleCards.length === cards.length) {
          resultCount.textContent =
            `${shownCount} affiché${shownCount > 1 ? 's' : ''} ` +
            `sur ${cards.length} produit${cards.length > 1 ? 's' : ''}`;
        } else {
          resultCount.textContent =
            `${shownCount} affiché${shownCount > 1 ? 's' : ''} · ` +
            `${eligibleCards.length} résultat${
              eligibleCards.length > 1 ? 's' : ''
            } compatible${
              eligibleCards.length > 1 ? 's' : ''
            } sur ${cards.length}`;
        }
      }

      const showMoreButton = step.querySelector(
        '[data-pc-show-more]'
      );
      const remaining = Math.max(
        eligibleCards.length - state.limit,
        0
      );

      if (showMoreButton) {
        showMoreButton.hidden = remaining === 0;
        const nextCount = Math.min(getBatchSize(), remaining);
        showMoreButton.textContent =
          `Afficher ${nextCount} produit${nextCount > 1 ? 's' : ''} de plus`;
      }

      const emptyResults = step.querySelector(
        '[data-pc-empty-results]'
      );

      if (emptyResults) {
        emptyResults.hidden = eligibleCards.length > 0;
      }
    }

    function refreshAllCatalogs() {
      steps.forEach((step) => {
        refreshCatalog(step.dataset.category);
      });
    }

    function activateStep(category, openMobile = true) {
      const step = getStep(category);
      if (!step) return;

      activeCategory = category;

      steps.forEach((candidate) => {
        const isActive = candidate === step;
        candidate.classList.toggle('is-active', isActive);
        candidate.setAttribute(
          'aria-hidden',
          String(!isActive)
        );

        if (!isActive) {
          const panel = candidate.querySelector(
            '[data-pc-filters-panel]'
          );
          const toggle = candidate.querySelector(
            '[data-pc-toggle-filters]'
          );
          panel?.classList.remove('is-open');
          toggle?.setAttribute('aria-expanded', 'false');
        }
      });

      navigationItems.forEach((item) => {
        const isActive = item.dataset.category === category;
        item.classList.toggle('is-active', isActive);
        item
          .querySelector('[data-pc-open-step]')
          ?.setAttribute(
            'aria-current',
            isActive ? 'step' : 'false'
          );
      });

      if (activeLabelElement) {
        activeLabelElement.textContent =
          step.dataset.label || '';
      }

      if (
        openMobile &&
        window.matchMedia('(max-width: 989px)').matches
      ) {
        root.classList.add('is-catalog-open');
        root
          .querySelector('[data-pc-catalog]')
          ?.scrollIntoView({ block: 'start' });
      }

      refreshCatalog(category);
    }

    function closeMobileCatalog() {
      root.classList.remove('is-catalog-open');
      const activeNavigationButton = openStepButtons.find(
        (button) => button.dataset.category === activeCategory
      );
      activeNavigationButton?.focus({ preventScroll: true });

      requestAnimationFrame(() => {
        activeNavigationButton?.scrollIntoView({
          block: 'center',
          behavior: 'auto'
        });
      });
    }

    function renderNavigation() {
      navigationItems.forEach((item) => {
        const category = item.dataset.category;
        const selection = selections.get(category);
        const placeholder = item.querySelector(
          '[data-pc-nav-placeholder]'
        );
        const selectionElement = item.querySelector(
          '[data-pc-nav-selection]'
        );
        const image = item.querySelector('[data-pc-nav-image]');
        const title = item.querySelector('[data-pc-nav-title]');
        const price = item.querySelector('[data-pc-nav-price]');
        const removeButton = item.querySelector(
          '[data-pc-remove-category]'
        );

        item.classList.toggle('is-selected', Boolean(selection));

        if (!selection) {
          if (placeholder) placeholder.hidden = false;
          if (selectionElement) selectionElement.hidden = true;
          if (removeButton) removeButton.hidden = true;
          if (image) {
            image.removeAttribute('src');
            image.alt = '';
          }
          return;
        }

        if (placeholder) placeholder.hidden = true;
        if (selectionElement) selectionElement.hidden = false;
        if (removeButton) removeButton.hidden = false;
        if (title) title.textContent = selection.title;
        if (price) price.textContent = formatMoney(selection.price);

        if (image) {
          image.src = selection.imageSrc || '';
          image.alt = selection.imageAlt || selection.title;
          image.hidden = !selection.imageSrc;
        }
      });
    }

    function removeCategorySelection(category) {
      const step = getStep(category);

      step
        ?.querySelectorAll('[data-pc-product]')
        .forEach((button) => {
          button.setAttribute('aria-pressed', 'false');
        });

      selections.delete(category);

      if (category === 'cpu') {
        activeMotherboardSocket = 'all';
        activeMotherboardChipset = 'all';
        applyMotherboardFilters();
      }

      updateCompatibility();
      renderSummary();
    }

    function resetCatalogFilters(category) {
      const step = getStep(category);
      const state = getCatalogState(category);

      state.query = '';
      state.vendor = 'all';
      state.facets = {};
      state.sort = 'price-asc';
      state.limit = getBatchSize();

      const searchInput = step?.querySelector('[data-pc-search]');
      const sortSelect = step?.querySelector('[data-pc-sort]');
      if (searchInput) searchInput.value = '';
      if (sortSelect) sortSelect.value = 'price-asc';

      step
        ?.querySelectorAll('[data-pc-vendor-filter]')
        .forEach((button) => {
          const isActive =
            button.dataset.pcVendorFilter === 'all';
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });

      step?.querySelectorAll('[data-pc-facet-group]').forEach((group) => {
        group.querySelectorAll('[data-pc-facet-value]').forEach((button) => {
          const active = button.dataset.pcFacetValue === 'all';
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
      });

      if (category === 'cpu') {
        activeCpuBrand = 'all';
        activeCpuSocket = 'all';
        applyCpuFilters(true);
      } else if (category === 'motherboard') {
        activeMotherboardSocket =
          selections.get('cpu')?.specs?.socket || 'all';
        activeMotherboardChipset = 'all';
        applyMotherboardFilters();
      } else if (category === 'cooling') {
        activeCoolingType = 'all';
        activeCoolingRadiatorSize = 'all';
        applyCoolingFilters();
      }

      refreshCatalog(category, { resetLimit: true });
    }

    const informationModal = root.querySelector(
      '[data-pc-info-modal]'
    );

    function closeProductInformation() {
      if (!informationModal || informationModal.hidden) return;

      informationModal.hidden = true;
      document.body.classList.remove(
        'pc-configurator-modal-open'
      );
      activeInformationUrl = '';
      lastInformationTrigger?.focus({ preventScroll: true });
      lastInformationTrigger = null;
    }

    async function openProductInformation(trigger) {
      if (!informationModal) return;

      const card = trigger.closest(
        '.pc-configurator__product-card'
      );
      const productButton = card?.querySelector(
        '[data-pc-product]'
      );
      if (!productButton) return;

      lastInformationTrigger = trigger;

      const imageElement = productButton.querySelector(
        '[data-pc-product-image]'
      );
      const modalImage = informationModal.querySelector(
        '[data-pc-info-image]'
      );
      const modalVendor = informationModal.querySelector(
        '[data-pc-info-vendor]'
      );
      const modalTitle = informationModal.querySelector(
        '[data-pc-info-title]'
      );
      const modalPrice = informationModal.querySelector(
        '[data-pc-info-price]'
      );
      const modalDescription = informationModal.querySelector(
        '[data-pc-info-description]'
      );
      const modalLink = informationModal.querySelector(
        '[data-pc-info-link]'
      );
      const productUrl = productButton.dataset.productUrl || '';
      activeInformationUrl = productUrl;

      if (modalImage) {
        const informationImageSrc =
          imageElement?.currentSrc || imageElement?.src || '';

        if (informationImageSrc) {
          modalImage.src = informationImageSrc;
        } else {
          modalImage.removeAttribute('src');
        }

        modalImage.hidden = !informationImageSrc;
        modalImage.alt =
          imageElement?.alt ||
          productButton.dataset.productTitle ||
          '';
      }
      if (modalVendor) {
        modalVendor.textContent =
          productButton.dataset.productVendor || '';
      }
      if (modalTitle) {
        modalTitle.textContent =
          productButton.dataset.productTitle || '';
      }
      if (modalPrice) {
        modalPrice.textContent = formatMoney(
          parseNumber(productButton.dataset.price)
        );
      }
      if (modalDescription) {
        modalDescription.textContent =
          'Chargement de la description et de la fiche technique…';
      }
      if (modalLink) {
        modalLink.href = productUrl || '#';
      }

      informationModal.hidden = false;
      document.body.classList.add('pc-configurator-modal-open');
      informationModal
        .querySelector('[data-pc-close-info]')
        ?.focus();

      if (!productUrl || !modalDescription) return;

      try {
        let productData = productInformationCache.get(productUrl);

        if (!productData) {
          const cleanProductUrl = productUrl
            .split('?')[0]
            .replace(/\.js$/, '');
          const response = await fetch(`${cleanProductUrl}.js`, {
            headers: { Accept: 'application/json' }
          });

          if (!response.ok) {
            throw new Error('Informations indisponibles');
          }

          productData = await response.json();
          productInformationCache.set(productUrl, productData);
        }

        if (
          informationModal.hidden ||
          activeInformationUrl !== productUrl
        ) {
          return;
        }

        if (modalTitle && productData.title) {
          modalTitle.textContent = productData.title;
        }
        if (modalVendor && productData.vendor) {
          modalVendor.textContent = productData.vendor;
        }

        modalDescription.innerHTML =
          productData.description ||
          '<p>Aucune description détaillée n’est disponible pour ce produit.</p>';

        modalDescription
          .querySelectorAll('script')
          .forEach((script) => script.remove());
      } catch (error) {
        modalDescription.innerHTML =
          '<p>La description ne peut pas être chargée pour le moment. ' +
          'Vous pouvez consulter la fiche produit complète.</p>';
      }
    }

    buildMetaobjectFilters();
    buildFacetFilters();
    buildVendorFilters();

    openStepButtons.forEach((button) => {
      button.addEventListener('click', () => {
        activateStep(button.dataset.category);
      });
    });

    closeCatalogButton?.addEventListener(
      'click',
      closeMobileCatalog
    );

    steps.forEach((step) => {
      const category = step.dataset.category;
      const searchInput = step.querySelector('[data-pc-search]');
      const sortSelect = step.querySelector('[data-pc-sort]');
      const filtersToggle = step.querySelector(
        '[data-pc-toggle-filters]'
      );
      const filtersPanel = step.querySelector(
        '[data-pc-filters-panel]'
      );
      const showMoreButton = step.querySelector(
        '[data-pc-show-more]'
      );
      const clearButton = step.querySelector(
        '[data-pc-clear-catalog]'
      );

      searchInput?.addEventListener('input', () => {
        window.clearTimeout(searchTimer);
        searchTimer = window.setTimeout(() => {
          const state = getCatalogState(category);
          state.query = searchInput.value;
          refreshCatalog(category, { resetLimit: true });
        }, 180);
      });

      sortSelect?.addEventListener('change', () => {
        step.querySelectorAll('[data-pc-product]').forEach((product) => {
          product.dataset.sortPrice = product.dataset.price || '0';
        });
        const state = getCatalogState(category);
        state.sort = sortSelect.value;
        refreshCatalog(category, { resetLimit: true });
      });

      filtersToggle?.addEventListener('click', () => {
        const isOpen = filtersPanel?.classList.toggle('is-open');
        filtersToggle.setAttribute(
          'aria-expanded',
          String(Boolean(isOpen))
        );
      });

      showMoreButton?.addEventListener('click', () => {
        const state = getCatalogState(category);
        state.limit += getBatchSize();
        refreshCatalog(category);
      });

      clearButton?.addEventListener('click', () => {
        resetCatalogFilters(category);
      });
    });

    root.addEventListener('click', (event) => {
      const facetButton = event.target.closest('[data-pc-facet-value]');
      if (facetButton && root.contains(facetButton)) {
        const group = facetButton.closest('[data-pc-facet-group]');
        const step = facetButton.closest('[data-pc-step]');
        if (!step || !group) return;
        const state = getCatalogState(step.dataset.category);
        state.facets[group.dataset.pcFacetGroup] = facetButton.dataset.pcFacetValue;
        group.querySelectorAll('[data-pc-facet-value]').forEach((button) => {
          const active = button === facetButton;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
        refreshCatalog(step.dataset.category, { resetLimit: true });
        return;
      }
      const vendorButton = event.target.closest(
        '[data-pc-vendor-filter]'
      );

      if (vendorButton && root.contains(vendorButton)) {
        const step = vendorButton.closest('[data-pc-step]');
        const category = step?.dataset.category;
        if (!category) return;

        const state = getCatalogState(category);
        state.vendor = vendorButton.dataset.pcVendorFilter || 'all';

        step
          .querySelectorAll('[data-pc-vendor-filter]')
          .forEach((button) => {
            const isActive = button === vendorButton;
            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-pressed', String(isActive));
          });

        refreshCatalog(category, { resetLimit: true });
        return;
      }

      const informationButton = event.target.closest(
        '[data-pc-product-info]'
      );

      if (informationButton && root.contains(informationButton)) {
        openProductInformation(informationButton);
        return;
      }

      const removeNavigationButton = event.target.closest(
        '[data-pc-remove-category]'
      );

      if (
        removeNavigationButton &&
        root.contains(removeNavigationButton)
      ) {
        removeCategorySelection(
          removeNavigationButton.dataset.pcRemoveCategory
        );
        return;
      }

      const technicalFilter = event.target.closest(
        '[data-pc-cpu-brand-filter], ' +
          '[data-pc-cpu-socket-filter], ' +
          '[data-pc-motherboard-socket-filter], ' +
          '[data-pc-motherboard-chipset-filter], ' +
          '[data-pc-cooling-type-filter], ' +
          '[data-pc-radiator-size-filter]'
      );

      if (technicalFilter && root.contains(technicalFilter)) {
        const category = technicalFilter.closest('[data-pc-step]')
          ?.dataset.category;
        if (category) {
          requestAnimationFrame(() => {
            refreshCatalog(category, { resetLimit: true });
          });
        }
      }
    });

    informationModal
      ?.querySelectorAll('[data-pc-close-info]')
      .forEach((button) => {
        button.addEventListener('click', closeProductInformation);
      });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      if (
        event.target instanceof Element &&
        event.target.matches('input, select, textarea')
      ) {
        return;
      }

      if (informationModal && !informationModal.hidden) {
        closeProductInformation();
      } else if (root.classList.contains('is-catalog-open')) {
        closeMobileCatalog();
      }
    });

    activateStep(activeCategory, false);
    const cpuBrandFilterStep = root.querySelector(
  '[data-pc-step][data-category="cpu"]'
);

const cpuBrandFilterButtons = cpuBrandFilterStep
  ? Array.from(
      cpuBrandFilterStep.querySelectorAll(
        '[data-pc-cpu-brand-filter]'
      )
    )
  : [];

const cpuBrandFilterProducts = cpuBrandFilterStep
  ? Array.from(
      cpuBrandFilterStep.querySelectorAll('[data-pc-product]')
    )
  : [];

const cpuBrandFilterCount = cpuBrandFilterStep
  ? cpuBrandFilterStep.querySelector(
      '.pc-configurator__collection-count'
    )
  : null;

const cpuBrandFilterList = cpuBrandFilterStep
  ? cpuBrandFilterStep.querySelector(
      '.pc-configurator__products'
    )
  : null;
const cpuSocketFilterButtons = cpuBrandFilterStep
  ? Array.from(
      cpuBrandFilterStep.querySelectorAll(
        '[data-pc-cpu-socket-filter]'
      )
    )
  : [];

let activeCpuBrand = 'all';
let activeCpuSocket = 'all';
function resetCpuFilterCarousel(force = false) {
  if (!cpuBrandFilterList) return;

  if (
    !force &&
    window.matchMedia('(max-width: 749px)').matches &&
    selections.has('cpu')
  ) {
    return;
  }

  const previousScrollBehavior =
    cpuBrandFilterList.style.scrollBehavior;

  cpuBrandFilterList.style.scrollBehavior = 'auto';

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      cpuBrandFilterList.scrollTo({
        left: 0,
        top: 0,
        behavior: 'auto'
      });

      cpuBrandFilterList.dispatchEvent(
        new Event('scroll')
      );

      cpuBrandFilterList.style.scrollBehavior =
        previousScrollBehavior;
    });
  });
}

function applyCpuFilters(forceCarouselReset = false) {
  let visibleCount = 0;

  const selectedMotherboard =
    selections.get('motherboard')?.specs || null;

  const effectiveCpuSocket =
    selectedMotherboard?.socket || activeCpuSocket;

  const selectedSocketButton = selectedMotherboard
    ? cpuSocketFilterButtons.find(
        (filterButton) =>
          filterButton.dataset.pcCpuSocketFilter ===
          effectiveCpuSocket
      )
    : null;

  const motherboardCpuBrand =
    selectedSocketButton?.dataset.pcSocketBrand || '';

  const effectiveCpuBrand = selectedMotherboard
    ? motherboardCpuBrand || 'all'
    : activeCpuBrand;

  const requiredMotherboardChipset =
    selectedMotherboard?.chipset || 'all';

  cpuBrandFilterProducts.forEach((productButton) => {
    const compatibleChipsets = parseList(
      productButton.dataset.compatibleChipsets
    );

    const matchesBrand =
      effectiveCpuBrand === 'all' ||
      productButton.dataset.cpuBrand ===
        effectiveCpuBrand;

    const matchesSocket =
      effectiveCpuSocket === 'all' ||
      productButton.dataset.socket ===
        effectiveCpuSocket;

    const matchesChipset =
      requiredMotherboardChipset === 'all' ||
      compatibleChipsets.includes(
        requiredMotherboardChipset
      );

    const isVisible =
      matchesBrand &&
      matchesSocket &&
      matchesChipset;

    const productCard = productButton.closest(
      '.pc-configurator__product-card'
    );

    const filterTarget =
      productCard || productButton;

    productButton.classList.remove(
      'is-brand-filtered-out'
    );

    filterTarget.classList.toggle(
      'is-brand-filtered-out',
      !isVisible
    );

    if (isVisible) {
      visibleCount += 1;
    }
  });

  cpuBrandFilterButtons.forEach((filterButton) => {
    const isActive =
      filterButton.dataset.pcCpuBrandFilter ===
      effectiveCpuBrand;

    filterButton.classList.toggle(
      'is-active',
      isActive
    );

    filterButton.setAttribute(
      'aria-pressed',
      String(isActive)
    );
  });

  cpuSocketFilterButtons.forEach((filterButton) => {
    const socketBrand =
      filterButton.dataset.pcSocketBrand || '';

    const isRelevant =
      effectiveCpuBrand === 'all' ||
      socketBrand === '' ||
      socketBrand === effectiveCpuBrand;

    filterButton.hidden = !isRelevant;

    const isActive =
      filterButton.dataset.pcCpuSocketFilter ===
      effectiveCpuSocket;

    filterButton.classList.toggle(
      'is-active',
      isActive
    );

    filterButton.setAttribute(
      'aria-pressed',
      String(isActive)
    );
  });

  if (cpuBrandFilterCount) {
    const totalCount =
      cpuBrandFilterProducts.length;

    if (
      effectiveCpuBrand === 'all' &&
      effectiveCpuSocket === 'all' &&
      requiredMotherboardChipset === 'all'
    ) {
      cpuBrandFilterCount.textContent =
        `${totalCount} ${
          totalCount === 1
            ? 'produit'
            : 'produits'
        }`;
    } else {
      cpuBrandFilterCount.textContent =
        `${visibleCount} ${
          visibleCount === 1
            ? 'processeur affiché'
            : 'processeurs affichés'
        } sur ${totalCount}`;
    }
  }

  resetCpuFilterCarousel(forceCarouselReset);
}

cpuBrandFilterButtons.forEach((filterButton) => {
  filterButton.addEventListener('click', () => {
    const selectedBrand =
      filterButton.dataset.pcCpuBrandFilter;

    if (
      selectedBrand !== 'all' &&
      activeCpuSocket !== 'all'
    ) {
      const selectedSocketButton =
        cpuSocketFilterButtons.find(
          (socketButton) =>
            socketButton.dataset.pcCpuSocketFilter ===
            activeCpuSocket
        );

      const socketBrand =
        selectedSocketButton?.dataset.pcSocketBrand || '';

      if (
        socketBrand &&
        socketBrand !== selectedBrand
      ) {
        activeCpuSocket = 'all';
      }
    }

    activeCpuBrand = selectedBrand;
    applyCpuFilters(true);
    applyCpuFilters();
  });
});

cpuSocketFilterButtons.forEach((filterButton) => {
  filterButton.addEventListener('click', () => {
    activeCpuSocket =
      filterButton.dataset.pcCpuSocketFilter;
      applyCpuFilters(true);

    applyCpuFilters();
  });
});
applyCpuFilters();
const motherboardFilterStep = root.querySelector(
  '[data-pc-step][data-category="motherboard"]'
);

const motherboardFilterList = motherboardFilterStep
  ? motherboardFilterStep.querySelector(
      '.pc-configurator__products'
    )
  : null;
const motherboardFilterCount =
  motherboardFilterStep
    ? motherboardFilterStep.querySelector(
        '.pc-configurator__collection-count'
      )
    : null;
const motherboardProducts = motherboardFilterStep
  ? Array.from(
      motherboardFilterStep.querySelectorAll(
        '[data-pc-product]'
      )
    )
  : [];

const motherboardSocketButtons = motherboardFilterStep
  ? Array.from(
      motherboardFilterStep.querySelectorAll(
        '[data-pc-motherboard-socket-filter]'
      )
    )
  : [];

const motherboardChipsetButtons = motherboardFilterStep
  ? Array.from(
      motherboardFilterStep.querySelectorAll(
        '[data-pc-motherboard-chipset-filter]'
      )
    )
  : [];

let activeMotherboardSocket = 'all';
let activeMotherboardChipset = 'all';

function resetMotherboardFilterCarousel() {
  if (!motherboardFilterList) return;

  const previousScrollBehavior =
    motherboardFilterList.style.scrollBehavior;

  motherboardFilterList.style.scrollBehavior = 'auto';

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      motherboardFilterList.scrollTo({
        left: 0,
        top: 0,
        behavior: 'auto'
      });

      motherboardFilterList.dispatchEvent(
        new Event('scroll')
      );

      motherboardFilterList.style.scrollBehavior =
        previousScrollBehavior;
    });
  });
}

function applyMotherboardFilters() {
  let visibleCount = 0;
  motherboardProducts.forEach((productButton) => {
    const matchesSocket =
      activeMotherboardSocket === 'all' ||
      productButton.dataset.socket ===
        activeMotherboardSocket;

    const matchesChipset =
      activeMotherboardChipset === 'all' ||
      productButton.dataset.chipset ===
        activeMotherboardChipset;

    const isVisible = matchesSocket && matchesChipset;

    const productCard = productButton.closest(
      '.pc-configurator__product-card'
    );

    const filterTarget = productCard || productButton;

    productButton.classList.remove(
      'is-brand-filtered-out'
    );

    filterTarget.classList.toggle(
      'is-brand-filtered-out',
      !isVisible
    );
        if (isVisible) {
      visibleCount += 1;
    }
  });

  motherboardSocketButtons.forEach((filterButton) => {
    const isActive =
      filterButton.dataset
        .pcMotherboardSocketFilter ===
      activeMotherboardSocket;

    filterButton.classList.toggle(
      'is-active',
      isActive
    );

    filterButton.setAttribute(
      'aria-pressed',
      String(isActive)
    );
  });

  motherboardChipsetButtons.forEach((filterButton) => {
    const chipsetSockets = parseList(filterButton.dataset.pcChipsetSockets);

    const isRelevant =
      activeMotherboardSocket === 'all' ||
      filterButton.dataset.pcMotherboardChipsetFilter === 'all' ||
      chipsetSockets.includes(activeMotherboardSocket);

    filterButton.hidden = !isRelevant;

    const isActive =
      filterButton.dataset
        .pcMotherboardChipsetFilter ===
      activeMotherboardChipset;

    filterButton.classList.toggle(
      'is-active',
      isActive
    );

    filterButton.setAttribute(
      'aria-pressed',
      String(isActive)
    );
  });
  if (motherboardFilterCount) {
    const totalCount = motherboardProducts.length;

    if (
      activeMotherboardSocket === 'all' &&
      activeMotherboardChipset === 'all'
    ) {
      motherboardFilterCount.textContent =
        `${totalCount} ${
          totalCount === 1 ? 'produit' : 'produits'
        }`;
    } else {
      motherboardFilterCount.textContent =
        `${visibleCount} ${
          visibleCount === 1
            ? 'carte mère affichée'
            : 'cartes mères affichées'
        } sur ${totalCount}`;
    }
  }
  resetMotherboardFilterCarousel();
}

motherboardSocketButtons.forEach((filterButton) => {
  filterButton.addEventListener('click', () => {
    const selectedSocket =
      filterButton.dataset
        .pcMotherboardSocketFilter;

    if (
      selectedSocket !== 'all' &&
      activeMotherboardChipset !== 'all'
    ) {
      const activeChipsetButton =
        motherboardChipsetButtons.find(
          (chipsetButton) =>
            chipsetButton.dataset
              .pcMotherboardChipsetFilter ===
            activeMotherboardChipset
        );

      const chipsetSockets = parseList(activeChipsetButton?.dataset.pcChipsetSockets);

      if (!chipsetSockets.includes(selectedSocket)) {
        activeMotherboardChipset = 'all';
      }
    }

    activeMotherboardSocket = selectedSocket;
    applyMotherboardFilters();
  });
});

motherboardChipsetButtons.forEach((filterButton) => {
  filterButton.addEventListener('click', () => {
    activeMotherboardChipset =
      filterButton.dataset
        .pcMotherboardChipsetFilter;

    applyMotherboardFilters();
  });
});

applyMotherboardFilters();
const cpuCompatibilityProducts = Array.from(
  root.querySelectorAll(
    '[data-pc-step][data-category="cpu"] [data-pc-product]'
  )
);

cpuCompatibilityProducts.forEach((productButton) => {
  productButton.addEventListener('click', () => {
    const selectedCpuSocket =
      productButton.dataset.socket || 'all';

    activeMotherboardSocket = selectedCpuSocket;
    activeMotherboardChipset = 'all';

    applyMotherboardFilters();
  });
});
const coolingFilterStep = root.querySelector(
  '[data-pc-step][data-category="cooling"]'
);

const coolingFilterList = coolingFilterStep
  ? coolingFilterStep.querySelector(
      '.pc-configurator__products'
    )
  : null;
const coolingFilterCount = coolingFilterStep
  ? coolingFilterStep.querySelector(
      '.pc-configurator__collection-count'
    )
  : null;
const coolingProducts = coolingFilterStep
  ? Array.from(
      coolingFilterStep.querySelectorAll(
        '[data-pc-product]'
      )
    )
  : [];

const coolingTypeButtons = coolingFilterStep
  ? Array.from(
      coolingFilterStep.querySelectorAll(
        '[data-pc-cooling-type-filter]'
      )
    )
  : [];

const coolingRadiatorSizeButtons = coolingFilterStep
  ? Array.from(
      coolingFilterStep.querySelectorAll(
        '[data-pc-radiator-size-filter]'
      )
    )
  : [];

const coolingRadiatorSizeGroup = coolingFilterStep
  ? coolingFilterStep.querySelector(
      '[data-pc-cooling-size-filters]'
    )
  : null;

let activeCoolingType = 'all';
let activeCoolingRadiatorSize = 'all';

function getCoolingProductType(productButton) {
  const declaredType = String(
    productButton.dataset.coolingType || ''
  ).toLowerCase();

  const productTitle = String(
    productButton.dataset.productTitle || ''
  ).toLowerCase();

  const searchableValue =
    `${declaredType} ${productTitle}`;

  /*
   * Watercooling détecté par le métachamp,
   * le titre ou la présence d'une taille de radiateur.
   */
  if (
    productButton.dataset.radiatorSize ||
    /water|watercooling|aio|liquid|liquide|eau/.test(
      searchableValue
    )
  ) {
    return 'watercooling';
  }

  /*
   * Ventirad détecté par le métachamp,
   * le titre ou la présence d'une hauteur.
   */
  if (
    Number(productButton.dataset.coolerHeight) > 0 ||
    /ventirad|air-cooling|air-cooler|refroidissement-(par-)?air/.test(
      searchableValue
    )
  ) {
    return 'ventirad';
  }

  return declaredType;
}

function getCoolingRadiatorSize(productButton) {
  const radiatorSize = String(
    productButton.dataset.radiatorSize || ''
  );

  const radiatorSizeMatch = radiatorSize.match(
    /(?:^|\D)(120|140|240|280|360|420)(?:\D|$)/
  );

  return radiatorSizeMatch
    ? radiatorSizeMatch[1]
    : '';
}

function resetCoolingFilterCarousel() {
  if (!coolingFilterList) return;

  const previousScrollBehavior =
    coolingFilterList.style.scrollBehavior;

  coolingFilterList.style.scrollBehavior = 'auto';

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      coolingFilterList.scrollTo({
        left: 0,
        top: 0,
        behavior: 'auto'
      });

      coolingFilterList.dispatchEvent(
        new Event('scroll')
      );

      coolingFilterList.style.scrollBehavior =
        previousScrollBehavior;
    });
  });
}

function applyCoolingFilters() {
  let visibleCount = 0;
  const showRadiatorSizeFilters =
    activeCoolingType === 'watercooling';

  if (coolingRadiatorSizeGroup) {
    coolingRadiatorSizeGroup.hidden =
      !showRadiatorSizeFilters;
  }

  if (!showRadiatorSizeFilters) {
    activeCoolingRadiatorSize = 'all';
  }

  coolingProducts.forEach((productButton) => {
    const productType =
      getCoolingProductType(productButton);

    const productRadiatorSize =
      getCoolingRadiatorSize(productButton);

    const matchesCoolingType =
      activeCoolingType === 'all' ||
      productType === activeCoolingType;

    const matchesRadiatorSize =
      activeCoolingType !== 'watercooling' ||
      activeCoolingRadiatorSize === 'all' ||
      productRadiatorSize ===
        activeCoolingRadiatorSize;

    const isVisible =
      matchesCoolingType &&
      matchesRadiatorSize;

    const productCard = productButton.closest(
      '.pc-configurator__product-card'
    );

    const filterTarget =
      productCard || productButton;

    productButton.classList.remove(
      'is-brand-filtered-out'
    );

    filterTarget.classList.toggle(
      'is-brand-filtered-out',
      !isVisible
    );
        if (isVisible) {
      visibleCount += 1;
    }
  });

  coolingTypeButtons.forEach((filterButton) => {
    const isActive =
      filterButton.dataset.pcCoolingTypeFilter ===
      activeCoolingType;

    filterButton.classList.toggle(
      'is-active',
      isActive
    );

    filterButton.setAttribute(
      'aria-pressed',
      String(isActive)
    );
  });

  coolingRadiatorSizeButtons.forEach(
    (filterButton) => {
      const isActive =
        filterButton.dataset
          .pcRadiatorSizeFilter ===
        activeCoolingRadiatorSize;

      filterButton.classList.toggle(
        'is-active',
        isActive
      );

      filterButton.setAttribute(
        'aria-pressed',
        String(isActive)
      );
    }
  );
  if (coolingFilterCount) {
    const totalCount = coolingProducts.length;

    if (
      activeCoolingType === 'all' &&
      activeCoolingRadiatorSize === 'all'
    ) {
      coolingFilterCount.textContent =
        `${totalCount} ${
          totalCount === 1 ? 'produit' : 'produits'
        }`;
    } else {
      coolingFilterCount.textContent =
        `${visibleCount} ${
          visibleCount === 1
            ? 'refroidissement affiché'
            : 'refroidissements affichés'
        } sur ${totalCount}`;
    }
  }
  resetCoolingFilterCarousel();
}

coolingTypeButtons.forEach((filterButton) => {
  filterButton.addEventListener('click', () => {
    const selectedType =
      filterButton.dataset.pcCoolingTypeFilter;

    /*
     * Un second clic sur le bouton actif
     * réaffiche tous les refroidissements.
     */
    activeCoolingType =
      activeCoolingType === selectedType
        ? 'all'
        : selectedType;

    activeCoolingRadiatorSize = 'all';

    applyCoolingFilters();
  });
});

coolingRadiatorSizeButtons.forEach(
  (filterButton) => {
    filterButton.addEventListener('click', () => {
      const selectedRadiatorSize =
        filterButton.dataset
          .pcRadiatorSizeFilter;

      activeCoolingRadiatorSize =
        activeCoolingRadiatorSize ===
        selectedRadiatorSize
          ? 'all'
          : selectedRadiatorSize;

      applyCoolingFilters();
    });
  }
);

applyCoolingFilters();
const ramFilterStep = root.querySelector(
  '[data-pc-step][data-category="ram"]'
);

const ramFilterList = ramFilterStep
  ? ramFilterStep.querySelector(
      '.pc-configurator__products'
    )
  : null;

const ramFilterProducts = ramFilterStep
  ? Array.from(
      ramFilterStep.querySelectorAll(
        '[data-pc-product]'
      )
    )
  : [];

function resetRamFilterCarousel(force = false) {
  if (!ramFilterList) return;

  if (
    !force &&
    window.matchMedia('(max-width: 749px)').matches &&
    selections.has('ram')
  ) {
    return;
  }

  const previousScrollBehavior =
    ramFilterList.style.scrollBehavior;

  ramFilterList.style.scrollBehavior = 'auto';

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      ramFilterList.scrollTo({
        left: 0,
        top: 0,
        behavior: 'auto'
      });

      ramFilterList.dispatchEvent(
        new Event('scroll')
      );

      ramFilterList.style.scrollBehavior =
        previousScrollBehavior;
    });
  });
}


    function isMemoryTypeCompatible(motherboardType, ramType) {
      if (!motherboardType || !ramType) return false;
      if (motherboardType === ramType) return true;
      // Seules les valeurs déclarant plusieurs types autorisent ces alternatives.
      // La DDR5 classique n'est jamais assimilée à de la RDIMM ou SO-DIMM.
      const alternatives = {
        'ddr-4-ou-ddr-5': ['ddr-4', 'ddr-5'],
        'ddr-5-udimm-ecc-ou-non-ecc': ['ddr-5', 'ddr-5-ecc-udimm'],
        'ddr-5-rdimm-ou-mrdimm': ['ddr-5-ecc-rdimm', 'ddr-5-ecc-mrdimm',
          'ddr-5-rdimm', 'ddr-5-mrdimm'],
        'ddr-4-ecc-rdimm-ou-lrdimm': ['ddr-4-ecc-rdimm', 'ddr-4-ecc-lrdimm']
      };
      return alternatives[motherboardType]?.includes(ramType) || false;
    }

function applyRamMemoryFilter() {
  const selectedMotherboard =
    selections.get('motherboard');

  const requiredMemoryType =
    selectedMotherboard?.specs?.memoryType || 'all';

  const selectedRam = selections.get('ram');

  /*
   * Retire une ancienne RAM devenue incompatible
   * si le type de carte mère change.
   */
  if (
    requiredMemoryType !== 'all' &&
    selectedRam?.specs?.memoryType &&
    !isMemoryTypeCompatible(requiredMemoryType, selectedRam.specs.memoryType)
  ) {
    selections.delete('ram');

    ramFilterProducts.forEach((productButton) => {
      productButton.setAttribute(
        'aria-pressed',
        'false'
      );
    });
  }

  ramFilterProducts.forEach((productButton) => {
    const isVisible =
      requiredMemoryType === 'all' ||
      isMemoryTypeCompatible(requiredMemoryType, productButton.dataset.memoryType);

    const productCard = productButton.closest(
      '.pc-configurator__product-card'
    );

    const filterTarget =
      productCard || productButton;

    productButton.classList.remove(
      'is-brand-filtered-out'
    );

    filterTarget.classList.toggle(
      'is-brand-filtered-out',
      !isVisible
    );
  });

  resetRamFilterCarousel();
}
const preparationChoices = Array.from(
  root.querySelectorAll('[data-pc-preparation-choice]')
);

const preparationAddons = Array.from(
  root.querySelectorAll('[data-pc-preparation-addon]')
);
const gpuUnmountedOption = root.querySelector(
  '[data-pc-gpu-unmounted]'
);
    const currency = root.dataset.currency || 'EUR';

    const requiredCategories = new Set(
      Array.from(
        root.querySelectorAll(
          '[data-pc-step][data-required="true"]'
        )
      ).map((step) => step.dataset.category)
    );

    function formatMoney(cents) {
      try {
        return new Intl.NumberFormat(
          document.documentElement.lang || 'fr-FR',
          {
            style: 'currency',
            currency
          }
        ).format(cents / 100);
      } catch (error) {
        return `${(cents / 100).toFixed(2)} ${currency}`;
      }
    }

    function parseList(value) {
      return String(value || '')
        .split('|')
        .map((item) => item.trim())
        .filter(Boolean);
    }

    function parseNumber(value) {
      const number = Number(value);
      return Number.isFinite(number) ? number : 0;
    }
function getSelectionTitle(productButton) {
  const productTitle =
    productButton.dataset.productTitle || '';

  const selectedVariant = productButton
    .closest('.pc-configurator__product-card')
    ?.querySelector(
      '[data-pc-variant][aria-pressed="true"]'
    );

  const variantTitle =
    selectedVariant?.dataset.variantTitle?.trim() || '';

  if (
    !variantTitle ||
    variantTitle === 'Default Title' ||
    variantTitle === 'Titre par défaut'
  ) {
    return productTitle;
  }

  return `${productTitle} — ${variantTitle}`;
}
    function getProductSpecs(button) {
  return {
    socket: button.dataset.socket || '',
    chipset: button.dataset.chipset || '',
    compatibleChipsets: parseList(
      button.dataset.compatibleChipsets
    ),

    memoryType: button.dataset.memoryType || '',
    ramSlots: parseNumber(button.dataset.ramSlots),
    ramMaxCapacity: parseNumber(
      button.dataset.ramMaxCapacity
    ),
    ramCapacity: parseNumber(button.dataset.ramCapacity),
    ramModules: parseNumber(button.dataset.ramModules),

    motherboardFormat:
      button.dataset.motherboardFormat || '',
    psuFormat:
      button.dataset.psuFormat || '',
    coolingType:
      button.dataset.coolingType || '',
    coolingKind: getCoolingProductType(button),
    radiatorSize:
      button.dataset.radiatorSize || '',

    supportedMotherboardFormats: parseList(
      button.dataset.supportedMotherboardFormats
    ),
    supportedPsuFormats: parseList(
      button.dataset.supportedPsuFormats
    ),
    supportedRadiatorSizes: parseList(
      button.dataset.supportedRadiatorSizes
    ),
    compatibleCoolingSockets: parseList(
      button.dataset.compatibleCoolingSockets
    ),

    gpuLength: parseNumber(
      button.dataset.gpuLength
    ),
    caseMaxGpuLength: parseNumber(
      button.dataset.caseMaxGpuLength
    ),

    coolerHeight: parseNumber(
      button.dataset.coolerHeight
    ),
    caseMaxCoolerHeight: parseNumber(
      button.dataset.caseMaxCoolerHeight
    ),

    cpuTdp: parseNumber(
      button.dataset.cpuTdp
    ),
    coolerTdp: parseNumber(
      button.dataset.coolerTdp
    ),

    psuPower: parseNumber(
      button.dataset.psuPower
    ),
    gpuRequiredPower: parseNumber(
      button.dataset.gpuRequiredPower
    )
  };
}
function hasIncompleteTechnicalData(category, specs) {
  switch (category) {
    case 'cpu':
      return (
        !specs.socket ||
        specs.compatibleChipsets.length === 0 ||
        specs.cpuTdp <= 0
      );

    case 'motherboard':
      return (
        !specs.socket ||
        !specs.chipset ||
        !specs.memoryType ||
        specs.ramSlots <= 0 ||
        specs.ramMaxCapacity <= 0 ||
        !specs.motherboardFormat
      );

    case 'ram':
      return (
        !specs.memoryType ||
        specs.ramCapacity <= 0 ||
        specs.ramModules <= 0
      );

    case 'gpu':
      return (
        specs.gpuLength <= 0 ||
        specs.gpuRequiredPower <= 0
      );

    case 'cooling':
      return (
        !specs.coolingType ||
        specs.compatibleCoolingSockets.length === 0 ||
        specs.coolerTdp <= 0 ||
        (
          specs.coolingKind === 'watercooling'
            ? (!specs.radiatorSize.trim() ||
                specs.radiatorSize.trim().toLowerCase() === 'aucun')
            : (specs.coolingKind !== 'ventirad' ||
                specs.coolerHeight <= 0)
        )
      );

    case 'case':
      return (
        specs.supportedMotherboardFormats.length === 0 ||
        specs.supportedPsuFormats.length === 0 ||
        // Une liste vide interdit les AIO, pas les ventirads.
        specs.caseMaxGpuLength <= 0 ||
        specs.caseMaxCoolerHeight <= 0
      );

    case 'psu':
      return (
        !specs.psuFormat ||
        specs.psuPower <= 0
      );

    default:
      return false;
  }
}
    function getCompatibilityReason(button) {
      const step = button.closest('[data-pc-step]');
      const category = step.dataset.category;
      const candidate = getProductSpecs(button);
if (hasIncompleteTechnicalData(category, candidate)) {
  return (
    'Données techniques incomplètes — ' +
    'sélection momentanément indisponible.'
  );
}
      const selectedCpu = selections.get('cpu')?.specs;
      const selectedMotherboard =
        selections.get('motherboard')?.specs;
      const selectedRam = selections.get('ram')?.specs;
      const selectedGpu = selections.get('gpu')?.specs;
const selectedCooling = selections.get('cooling')?.specs;
const selectedCase = selections.get('case')?.specs;
const selectedPsu = selections.get('psu')?.specs;

      /*
       * Processeur candidat comparé à la carte mère sélectionnée.
       */
      if (category === 'cpu' && selectedMotherboard) {
        if (
          candidate.socket &&
          selectedMotherboard.socket &&
          candidate.socket !== selectedMotherboard.socket
        ) {
          return 'Socket incompatible avec la carte mère sélectionnée.';
        }

        if (
          candidate.compatibleChipsets.length > 0 &&
          selectedMotherboard.chipset &&
          !candidate.compatibleChipsets.includes(
            selectedMotherboard.chipset
          )
        ) {
          return 'Chipset de la carte mère non compatible avec ce processeur.';
        }
      }

      /*
       * Carte mère candidate comparée au processeur sélectionné.
       */
      if (category === 'motherboard' && selectedCpu) {
        if (
          candidate.socket &&
          selectedCpu.socket &&
          candidate.socket !== selectedCpu.socket
        ) {
          return 'Socket incompatible avec le processeur sélectionné.';
        }

        if (
          selectedCpu.compatibleChipsets.length > 0 &&
          candidate.chipset &&
          !selectedCpu.compatibleChipsets.includes(
            candidate.chipset
          )
        ) {
          return 'Chipset non déclaré compatible avec le processeur sélectionné.';
        }
      }

      /*
       * RAM candidate comparée à la carte mère sélectionnée.
       */
      if (category === 'ram' && selectedMotherboard) {
        if (
          candidate.memoryType &&
          selectedMotherboard.memoryType &&
          !isMemoryTypeCompatible(selectedMotherboard.memoryType, candidate.memoryType)
        ) {
          return 'Type de mémoire incompatible avec la carte mère.';
        }

        if (
          candidate.ramModules > 0 &&
          selectedMotherboard.ramSlots > 0 &&
          candidate.ramModules > selectedMotherboard.ramSlots
        ) {
          return 'Ce kit contient plus de modules que la carte mère ne possède de slots.';
        }

        if (
          candidate.ramCapacity > 0 &&
          selectedMotherboard.ramMaxCapacity > 0 &&
          candidate.ramCapacity >
            selectedMotherboard.ramMaxCapacity
        ) {
          return 'Capacité supérieure à la limite de la carte mère.';
        }
      }

      /*
       * Carte mère candidate comparée à la RAM sélectionnée.
       */
      if (category === 'motherboard' && selectedRam) {
        if (
          candidate.memoryType &&
          selectedRam.memoryType &&
          !isMemoryTypeCompatible(candidate.memoryType, selectedRam.memoryType)
        ) {
          return 'Cette carte mère utilise un autre type de mémoire.';
        }

        if (
          selectedRam.ramModules > 0 &&
          candidate.ramSlots > 0 &&
          selectedRam.ramModules > candidate.ramSlots
        ) {
          return 'Cette carte mère ne possède pas assez de slots RAM.';
        }

        if (
          selectedRam.ramCapacity > 0 &&
          candidate.ramMaxCapacity > 0 &&
          selectedRam.ramCapacity >
            candidate.ramMaxCapacity
        ) {
          return 'Cette carte mère ne prend pas en charge cette capacité de RAM.';
        }
      }
/*
 * Carte graphique candidate comparée à l’alimentation sélectionnée.
 */
if (
  category === 'gpu' &&
  selectedPsu &&
  candidate.gpuRequiredPower > 0 &&
  selectedPsu.psuPower > 0 &&
  selectedPsu.psuPower < candidate.gpuRequiredPower
) {
  return 'L’alimentation sélectionnée n’est pas assez puissante pour cette carte graphique.';
}

/*
 * Alimentation candidate comparée à la carte graphique sélectionnée.
 */
if (
  category === 'psu' &&
  selectedGpu &&
  selectedGpu.gpuRequiredPower > 0 &&
  candidate.psuPower > 0 &&
  candidate.psuPower < selectedGpu.gpuRequiredPower
) {
  return 'Cette alimentation n’est pas assez puissante pour la carte graphique sélectionnée.';
}
/*
 * Compatibilité du socket entre carte mère et refroidissement, dans les
 * deux sens, même lorsque le processeur n'a pas encore été sélectionné.
 */
if (category === 'motherboard' && selectedCooling) {
  if (
    candidate.socket &&
    selectedCooling.compatibleCoolingSockets.length > 0 &&
    !selectedCooling.compatibleCoolingSockets.includes(candidate.socket)
  ) {
    return 'Le refroidissement sélectionné n’est pas compatible avec le socket de cette carte mère.';
  }
}

if (category === 'cooling' && selectedMotherboard) {
  if (
    selectedMotherboard.socket &&
    candidate.compatibleCoolingSockets.length > 0 &&
    !candidate.compatibleCoolingSockets.includes(selectedMotherboard.socket)
  ) {
    return 'Ce refroidissement n’est pas compatible avec le socket de la carte mère.';
  }
}

/*
 * Refroidissement candidat comparé au processeur sélectionné.
 */
if (category === 'cooling' && selectedCpu) {
  if (
    selectedCpu.socket &&
    candidate.compatibleCoolingSockets.length > 0 &&
    !candidate.compatibleCoolingSockets.includes(
      selectedCpu.socket
    )
  ) {
    return 'Ce refroidissement n’est pas compatible avec le socket du processeur.';
  }

  if (
    selectedCpu.cpuTdp > 0 &&
    candidate.coolerTdp > 0 &&
    selectedCpu.cpuTdp > candidate.coolerTdp
  ) {
    return 'Ce refroidissement n’est pas assez puissant pour ce processeur.';
  }
}

/*
 * Processeur candidat comparé au refroidissement sélectionné.
 */
if (category === 'cpu' && selectedCooling) {
  if (
    candidate.socket &&
    selectedCooling.compatibleCoolingSockets.length > 0 &&
    !selectedCooling.compatibleCoolingSockets.includes(
      candidate.socket
    )
  ) {
    return 'Le refroidissement sélectionné n’est pas compatible avec le socket de ce processeur.';
  }

  if (
    candidate.cpuTdp > 0 &&
    selectedCooling.coolerTdp > 0 &&
    candidate.cpuTdp > selectedCooling.coolerTdp
  ) {
    return 'Le refroidissement sélectionné n’est pas assez puissant pour ce processeur.';
  }
}
/*
 * Composants candidats comparés au boîtier sélectionné.
 */
if (
  category === 'motherboard' &&
  selectedCase &&
  candidate.motherboardFormat &&
  selectedCase.supportedMotherboardFormats.length > 0 &&
  !selectedCase.supportedMotherboardFormats.includes(
    candidate.motherboardFormat
  )
) {
  return 'Le format de cette carte mère n’est pas pris en charge par le boîtier.';
}

if (
  category === 'gpu' &&
  selectedCase &&
  candidate.gpuLength > 0 &&
  selectedCase.caseMaxGpuLength > 0 &&
  candidate.gpuLength > selectedCase.caseMaxGpuLength
) {
  return 'Cette carte graphique est trop longue pour le boîtier.';
}

if (category === 'cooling' && selectedCase) {
  if (
    candidate.coolingKind === 'ventirad' &&
    candidate.coolerHeight > 0 &&
    selectedCase.caseMaxCoolerHeight > 0 &&
    candidate.coolerHeight >
      selectedCase.caseMaxCoolerHeight
  ) {
    return 'Ce ventirad est trop haut pour le boîtier.';
  }

  if (
    candidate.coolingKind === 'watercooling' &&
    !selectedCase.supportedRadiatorSizes.includes(
      candidate.radiatorSize
    )
  ) {
    return 'La taille de ce radiateur AIO n’est pas prise en charge par le boîtier.';
  }
}

if (
  category === 'psu' &&
  selectedCase &&
  candidate.psuFormat &&
  selectedCase.supportedPsuFormats.length > 0 &&
  !selectedCase.supportedPsuFormats.includes(
    candidate.psuFormat
  )
) {
  return 'Le format de cette alimentation n’est pas compatible avec le boîtier.';
}
/*
 * Boîtier candidat comparé aux composants sélectionnés.
 */
if (category === 'case') {
  if (
    selectedMotherboard &&
    selectedMotherboard.motherboardFormat &&
    candidate.supportedMotherboardFormats.length > 0 &&
    !candidate.supportedMotherboardFormats.includes(
      selectedMotherboard.motherboardFormat
    )
  ) {
    return 'Ce boîtier ne prend pas en charge le format de la carte mère.';
  }

  if (
    selectedGpu &&
    selectedGpu.gpuLength > 0 &&
    candidate.caseMaxGpuLength > 0 &&
    selectedGpu.gpuLength > candidate.caseMaxGpuLength
  ) {
    return 'La carte graphique est trop longue pour ce boîtier.';
  }

  if (
    selectedCooling &&
    selectedCooling.coolingKind === 'ventirad' &&
    selectedCooling.coolerHeight > 0 &&
    candidate.caseMaxCoolerHeight > 0 &&
    selectedCooling.coolerHeight >
      candidate.caseMaxCoolerHeight
  ) {
    return 'Le ventirad est trop haut pour ce boîtier.';
  }

  if (
    selectedCooling &&
    selectedCooling.coolingKind === 'watercooling' &&
    !candidate.supportedRadiatorSizes.includes(
      selectedCooling.radiatorSize
    )
  ) {
    return 'La taille du radiateur AIO n’est pas prise en charge par ce boîtier.';
  }

  if (
    selectedPsu &&
    selectedPsu.psuFormat &&
    candidate.supportedPsuFormats.length > 0 &&
    !candidate.supportedPsuFormats.includes(
      selectedPsu.psuFormat
    )
  ) {
    return 'Le format de l’alimentation n’est pas compatible avec ce boîtier.';
  }
}
      return '';
    }

    function updateCompatibility() {
  applyRamMemoryFilter();
  applyCpuFilters();

  productButtons.forEach((button) => {
    const reason = getCompatibilityReason(button);

    const isAvailable =
      button.dataset.productAvailable === 'true';

    const selectedVariantIsAvailable =
      button.dataset.selectedVariantAvailable !== 'false';

    const selectedVariantIsUnavailable =
      isAvailable && !selectedVariantIsAvailable;

    const displayedReason =
      selectedVariantIsUnavailable
        ? 'Cette variante est actuellement indisponible. Son prix reste visible, mais elle ne peut pas être ajoutée à la configuration.'
        : reason;

    const message = button.querySelector(
      '[data-pc-compatibility-message]'
    );

    button.disabled =
      !isAvailable ||
      selectedVariantIsUnavailable ||
      Boolean(reason);

    button.classList.toggle(
      'is-incompatible',
      Boolean(reason)
    );

    button.classList.toggle(
      'is-variant-unavailable',
      selectedVariantIsUnavailable
    );

    if (message) {
      if (displayedReason) {
        message.textContent = displayedReason;
        message.hidden = false;
      } else {
        message.textContent = '';
        message.hidden = true;
      }
    }
  });

  refreshAllCatalogs();
}
    function getSelectedPreparation() {
  return (
    preparationChoices.find((input) => input.checked) ||
    null
  );
}

function getSelectedPreparationAddons() {
  return preparationAddons.filter(
    (input) => input.checked && !input.disabled
  );
}

function updatePreparationOptions() {
  const selectedPreparation =
    getSelectedPreparation();

  const preparationMode =
    selectedPreparation?.value || 'self';
    const storageStep = root.querySelector(
  '[data-pc-step][data-category="storage"]'
);

const storageBadge = storageStep?.querySelector(
  '.pc-configurator__optional, .pc-configurator__required'
);

const storageNavigationStatus = root.querySelector(
  '[data-pc-nav-item][data-category="storage"] ' +
    '.pc-configurator__component-heading small'
);

const storageIsRequired =
  preparationMode === 'complete';

if (storageBadge) {
  storageBadge.textContent =
    storageIsRequired ? 'Obligatoire' : 'Facultatif';

  storageBadge.classList.toggle(
    'pc-configurator__required',
    storageIsRequired
  );

  storageBadge.classList.toggle(
    'pc-configurator__optional',
    !storageIsRequired
  );
}

if (storageNavigationStatus) {
  storageNavigationStatus.textContent =
    storageIsRequired ? 'Obligatoire' : 'Facultatif';
}

  const biosAddon = root.querySelector(
    '[data-pc-preparation-addon="bios"]'
  );

  const boxesAddon = root.querySelector(
    '[data-pc-preparation-addon="boxes"]'
  );

  if (biosAddon) {
    const biosIsAvailable =
      biosAddon.dataset.available === 'true';

    const biosCanBeSelected =
      preparationMode === 'assembly' &&
      biosIsAvailable;

    biosAddon.disabled = !biosCanBeSelected;

    if (!biosCanBeSelected) {
      biosAddon.checked = false;
    }
  }

  if (boxesAddon) {
    const boxesAreAvailable =
      boxesAddon.dataset.available === 'true';

    const boxesCanBeSelected =
      (
        preparationMode === 'assembly' ||
        preparationMode === 'complete'
      ) &&
      boxesAreAvailable;

    boxesAddon.disabled = !boxesCanBeSelected;

    if (!boxesCanBeSelected) {
      boxesAddon.checked = false;
    }
  }
  if (gpuUnmountedOption) {
  const gpuOptionCanBeSelected =
    preparationMode === 'assembly' ||
    preparationMode === 'complete';

  gpuUnmountedOption.disabled =
    !gpuOptionCanBeSelected;

  if (!gpuOptionCanBeSelected) {
    gpuUnmountedOption.checked = false;
  }
}
}

function getPreparationTotal() {
  const selectedPreparation =
    getSelectedPreparation();

  let preparationTotal = 0;

  if (
    selectedPreparation &&
    selectedPreparation.value !== 'self'
  ) {
    preparationTotal += parseNumber(
      selectedPreparation.dataset.price
    );
  }

  getSelectedPreparationAddons().forEach(
    (addon) => {
      preparationTotal += parseNumber(
        addon.dataset.price
      );
    }
  );

  return preparationTotal;
}
function updateAddToCartButton() {
  if (!addToCartButton) return;

  const requiredComponentsAreSelected = Array.from(
    requiredCategories
  ).every(
    (category) => selections.has(category)
  );

  const selectedPreparation =
    getSelectedPreparation();

  const storageIsRequired =
    selectedPreparation?.value === 'complete';

  const storageIsSelected =
    selections.has('storage');

  addToCartButton.disabled =
    !requiredComponentsAreSelected ||
    (storageIsRequired && !storageIsSelected);
}
    function renderSummary() {
      summary.innerHTML = '';

      if (selections.size === 0) {
        const emptyItem = document.createElement('li');
        emptyItem.textContent = 'Aucun composant sélectionné.';
        summary.appendChild(emptyItem);
      } else {
        selections.forEach((selection) => {
          const item = document.createElement('li');
          item.className =
            'pc-configurator__summary-item';

          const category = document.createElement('span');
          category.textContent = selection.label;

          const title = document.createElement('strong');
          title.textContent = selection.title;

          const price = document.createElement('span');
          price.textContent = formatMoney(selection.price);

          const removeButton = document.createElement('button');

removeButton.type = 'button';
removeButton.className =
  'pc-configurator__summary-remove';

removeButton.setAttribute(
  'aria-label',
  `Retirer ${selection.title}`
);

removeButton.title =
  `Retirer ${selection.title}`;

removeButton.innerHTML = `
  <svg
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M4 7h16M10 11v6m4-6v6M9 7l1-3h4l1 3m-9 0 1 14h10l1-14"
    ></path>
  </svg>
`;

removeButton.addEventListener('click', () => {
  removeCategorySelection(selection.category);
});

item.append(
  category,
  title,
  price,
  removeButton
);

summary.appendChild(item);
        });
      }

      const componentsTotal = Array.from(
  selections.values()
).reduce(
  (sum, selection) => sum + selection.price,
  0
);

const total =
  componentsTotal + getPreparationTotal();

totalElement.textContent = formatMoney(total);
      updateAddToCartButton();
if (resetButton) {
  const selectedPreparation =
    getSelectedPreparation();

  const preparationWasChanged =
    (selectedPreparation?.value || 'self') !== 'self';

  const addonWasSelected =
    preparationAddons.some((input) => input.checked);

  const gpuOptionWasSelected =
    Boolean(gpuUnmountedOption?.checked);

  resetButton.disabled =
    selections.size === 0 &&
    !preparationWasChanged &&
    !addonWasSelected &&
    !gpuOptionWasSelected;
}
      const effectiveRequiredCategories =
  new Set(requiredCategories);

const selectedPreparation =
  getSelectedPreparation();

if (selectedPreparation?.value === 'complete') {
  effectiveRequiredCategories.add('storage');
}

const completedRequired = Array.from(
  effectiveRequiredCategories
).filter(
  (category) => selections.has(category)
).length;

progressElement.textContent =
  `${completedRequired} / ${effectiveRequiredCategories.size} ` +
  'étapes obligatoires complétées';
      renderNavigation();
    }
function resetConfiguration() {
  selections.clear();
  steps.forEach((step) => {
    resetCatalogFilters(step.dataset.category);
  });
const selfPreparation =
  preparationChoices.find(
    (input) => input.value === 'self'
  );

if (selfPreparation) {
  selfPreparation.checked = true;
}

preparationAddons.forEach((input) => {
  input.checked = false;
});
if (gpuUnmountedOption) {
  gpuUnmountedOption.checked = false;
}
updatePreparationOptions();
  productButtons.forEach((button) => {
    button.setAttribute('aria-pressed', 'false');
  });
root
  .querySelectorAll('[data-pc-variant-selector]')
  .forEach((variantSelector) => {
    const initialVariant =
  variantSelector.querySelector(
    '[data-pc-variant][data-variant-initial="true"][data-variant-available="true"]'
  ) ||
  variantSelector.querySelector(
    '[data-pc-variant][data-variant-available="true"]'
  ) ||
  variantSelector.querySelector(
    '[data-pc-variant][data-variant-initial="true"]'
  ) ||
  variantSelector.querySelector(
    '[data-pc-variant]'
  );

    if (!initialVariant) return;

    variantSelector
      .querySelectorAll('[data-pc-variant]')
      .forEach((button) => {
        button.setAttribute(
          'aria-pressed',
          button === initialVariant ? 'true' : 'false'
        );
      });

    const productCard = variantSelector.closest(
      '.pc-configurator__product-card'
    );

    const productButton = productCard?.querySelector(
      '[data-pc-product]'
    );

    if (!productButton) return;

    productButton.dataset.variantId =
      initialVariant.dataset.variantId || '';

    productButton.dataset.price =
      initialVariant.dataset.variantPrice || '0';
      productButton.dataset.selectedVariantAvailable =
  initialVariant.dataset.variantAvailable || 'false';

    const priceElement = productButton.querySelector(
      '[data-pc-product-price]'
    );

    if (priceElement) {
      priceElement.textContent = formatMoney(
        parseNumber(productButton.dataset.price)
      );
    }

    const imageElement = productButton.querySelector(
      '[data-pc-product-image]'
    );

    const imageSrc =
      initialVariant.dataset.variantImageSrc || '';

    if (imageElement && imageSrc) {
      imageElement.src = imageSrc;
      imageElement.alt =
        initialVariant.dataset.variantImageAlt ||
        productButton.dataset.productTitle ||
        '';
    }
  });
  if (cartMessage) {
    cartMessage.textContent = '';
    cartMessage.hidden = true;
  }

  if (addToCartButton) {
    addToCartButton.textContent =
      'Ajouter la configuration au panier';
  }

  updateCompatibility();
  renderSummary();
}
function getPreparationCartItems(
  configurationReference
) {
  const items = [];

  const selectedPreparation =
    getSelectedPreparation();

  if (
    selectedPreparation &&
    selectedPreparation.value !== 'self' &&
    selectedPreparation.dataset.variantId
  ) {
    const preparationTitle =
      selectedPreparation
        .closest('.pc-configurator__option')
        ?.querySelector(
          '.pc-configurator__option-content strong'
        )
        ?.textContent
        ?.trim() ||
      'Préparation du PC';

    items.push({
      id: Number(
        selectedPreparation.dataset.variantId
      ),
      quantity: 1,
      properties: {
        'Configuration': 'PC sur mesure',
        'Préparation': preparationTitle,
        'Référence configuration':
          configurationReference
      }
    });
  }

  getSelectedPreparationAddons().forEach(
    (addon) => {
      if (!addon.dataset.variantId) return;

      const addonTitle =
        addon
          .closest('.pc-configurator__option')
          ?.querySelector(
            '.pc-configurator__option-content strong'
          )
          ?.textContent
          ?.trim() ||
        'Option complémentaire';

      items.push({
        id: Number(addon.dataset.variantId),
        quantity: 1,
        properties: {
          'Configuration': 'PC sur mesure',
          'Option complémentaire': addonTitle,
          'Référence configuration':
            configurationReference
        }
      });
    }
  );

  return items;
}
async function addConfigurationToCart() {
  if (!addToCartButton || addToCartButton.disabled) return;
const configurationReference =
  `PC-${Date.now().toString().slice(-10)}`;
  const items = Array.from(
  selections.values()
).map((selection) => {
  const properties = {
    'Configuration': 'PC sur mesure',
    'Composant': selection.label,
    'Référence configuration':
      configurationReference
  };

  if (
    selection.category === 'gpu' &&
    gpuUnmountedOption?.checked &&
    !gpuUnmountedOption.disabled
  ) {
    properties['Consigne de montage'] =
      'Carte graphique livrée non montée';
  }

  return {
    id: Number(selection.variantId),
    quantity: 1,
    properties
  };
});

items.push(
  ...getPreparationCartItems(
    configurationReference
  )
);

  if (items.length === 0) return;

  addToCartButton.disabled = true;
  addToCartButton.textContent = 'Ajout en cours…';

  if (cartMessage) {
    cartMessage.textContent = '';
    cartMessage.hidden = true;
  }

  try {
    const response = await fetch(
      window.Shopify.routes.root + 'cart/add.js',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items })
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        data.description ||
          data.message ||
          'Impossible d’ajouter la configuration au panier.'
      );
    }

    if (cartMessage) {
      cartMessage.textContent =
        'Configuration ajoutée au panier.';
      cartMessage.hidden = false;
    }

    addToCartButton.textContent =
      'Configuration ajoutée au panier';
      setTimeout(() => {
  window.location.href =
    window.Shopify.routes.root + 'cart';
}, 700);
  } catch (error) {
    if (cartMessage) {
      cartMessage.textContent =
        error.message ||
        'Une erreur est survenue pendant l’ajout au panier.';
      cartMessage.hidden = false;
    }

    addToCartButton.textContent =
      'Ajouter la configuration au panier';

    updateAddToCartButton();
  }
}
if (addToCartButton) {
  addToCartButton.addEventListener(
    'click',
    addConfigurationToCart
  );
}
if (resetButton) {
  resetButton.addEventListener(
    'click',
    resetConfiguration
  );
}
    root.addEventListener('click', (event) => {
  const variantButton = event.target.closest(
    '[data-pc-variant]'
  );

  if (variantButton && root.contains(variantButton)) {
  const productCard = variantButton.closest(
    '.pc-configurator__product-card'
  );

  const productButton = productCard?.querySelector(
    '[data-pc-product]'
  );

  const variantSelector = variantButton.closest(
    '[data-pc-variant-selector]'
  );

  if (!productButton || !variantSelector) return;

  const variantIsAvailable =
    variantButton.dataset.variantAvailable === 'true';

  const step = productButton.closest('[data-pc-step]');
  const category = step?.dataset.category;

  const productWasSelected =
    productButton.getAttribute('aria-pressed') === 'true';

  variantSelector
    .querySelectorAll('[data-pc-variant]')
    .forEach((button) => {
      button.setAttribute('aria-pressed', 'false');
    });

  variantButton.setAttribute('aria-pressed', 'true');

  productButton.dataset.variantId =
    variantButton.dataset.variantId || '';

  productButton.dataset.price =
    variantButton.dataset.variantPrice || '0';

  productButton.dataset.selectedVariantAvailable =
    String(variantIsAvailable);

  const priceElement = productButton.querySelector(
    '[data-pc-product-price]'
  );

  if (priceElement) {
    priceElement.textContent = formatMoney(
      parseNumber(productButton.dataset.price)
    );
  }

  const imageElement = productButton.querySelector(
    '[data-pc-product-image]'
  );

  const imageSrc =
    variantButton.dataset.variantImageSrc || '';

  if (imageElement && imageSrc) {
    imageElement.src = imageSrc;
    imageElement.alt =
      variantButton.dataset.variantImageAlt ||
      productButton.dataset.productTitle ||
      '';
  }

  if (productWasSelected && step && category) {
    if (variantIsAvailable) {
      selections.set(category, {
        category,
        label: step.dataset.label,
        title: getSelectionTitle(productButton),
        variantId: productButton.dataset.variantId,
        price: parseNumber(productButton.dataset.price),
        specs: getProductSpecs(productButton),
        imageSrc:
          productButton.querySelector('[data-pc-product-image]')
            ?.currentSrc ||
          productButton.querySelector('[data-pc-product-image]')
            ?.src ||
          '',
        imageAlt:
          productButton.querySelector('[data-pc-product-image]')
            ?.alt ||
          productButton.dataset.productTitle ||
          ''
      });
    } else {
      productButton.setAttribute(
        'aria-pressed',
        'false'
      );

      selections.delete(category);
    }
  }

  updateCompatibility();
  renderSummary();

  return;
}

  const productButton = event.target.closest(
    '[data-pc-product]'
  );

  if (
  !productButton ||
  productButton.disabled ||
  productButton.dataset.selectedVariantAvailable === 'false'
) {
  return;
}

  const step = productButton.closest('[data-pc-step]');
  const category = step.dataset.category;

  step
    .querySelectorAll('[data-pc-product]')
    .forEach((button) => {
      button.setAttribute('aria-pressed', 'false');
    });

  productButton.setAttribute('aria-pressed', 'true');

  selections.set(category, {
    category,
    label: step.dataset.label,
    title: getSelectionTitle(productButton),
    variantId: productButton.dataset.variantId,
    price: parseNumber(productButton.dataset.price),
    specs: getProductSpecs(productButton),
    imageSrc:
      productButton.querySelector('[data-pc-product-image]')
        ?.currentSrc ||
      productButton.querySelector('[data-pc-product-image]')
        ?.src ||
      '',
    imageAlt:
      productButton.querySelector('[data-pc-product-image]')
        ?.alt ||
      productButton.dataset.productTitle ||
      ''
  });

  updateCompatibility();
  renderSummary();

  if (window.matchMedia('(max-width: 989px)').matches) {
    closeMobileCatalog();
  }
});

    preparationChoices.forEach((input) => {
  input.addEventListener('change', () => {
    updatePreparationOptions();
    renderSummary();
  });
});

preparationAddons.forEach((input) => {
  input.addEventListener('change', () => {
    renderSummary();
  });
});

updatePreparationOptions();
updateCompatibility();
renderSummary();
  }

  function initialiseAll(scope = document) {
    scope
      .querySelectorAll('[data-pc-configurator]')
      .forEach(prepareConfigurator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initialiseAll();
    });
  } else {
    initialiseAll();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initialiseAll(event.target);
    }
  );
})();
document
  .querySelectorAll('.pc-configurator__carousel-navigation')
  .forEach((navigation) => {
    const products = navigation.nextElementSibling;

    if (
      !products ||
      !products.classList.contains('pc-configurator__products')
    ) {
      return;
    }

    const previousButton = navigation.querySelector(
      '[data-pc-carousel-previous]'
    );

    const nextButton = navigation.querySelector(
      '[data-pc-carousel-next]'
    );

    if (!previousButton || !nextButton) return;

    function updateCarouselArrows() {
      const maximumScroll =
        products.scrollWidth - products.clientWidth;

      previousButton.disabled = products.scrollLeft <= 2;
      nextButton.disabled =
        products.scrollLeft >= maximumScroll - 2;
    }

    function moveCarousel(direction) {
      const productCard = products.querySelector(
        '.pc-configurator__product-card'
      );

      if (!productCard) return;

      const productsStyle = window.getComputedStyle(products);
      const gap =
        Number.parseFloat(productsStyle.columnGap) ||
        Number.parseFloat(productsStyle.gap) ||
        0;

      products.scrollBy({
        left:
          direction *
          (productCard.getBoundingClientRect().width + gap),
        behavior: 'smooth'
      });
    }

    previousButton.addEventListener('click', () => {
      moveCarousel(-1);
    });

    nextButton.addEventListener('click', () => {
      moveCarousel(1);
    });

    products.addEventListener(
      'scroll',
      updateCarouselArrows,
      { passive: true }
    );

    window.addEventListener(
      'resize',
      updateCarouselArrows
    );

    updateCarouselArrows();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
